import { GET } from '@/app/api/index';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import atom from '@/app/editor/iframe/atom';
import { base, elementTypes, moduleTypes, rowTypes } from '@/app/editor/sidebar/constant';
import api from '@/app/endpoints.js';
import store from '@/app/store/store';
import { changeProductTitlePreview, getProductLatest } from '@/app/utils/assignedProductHelper';
import { checkKeyValid } from '@/app/utils/checkRoleApply.ts';
import hasImageUploadCare from '@/app/utils/hasImageUploadCare';
import { getFileExtensionFromSource, listForms } from '@/app/utils/helpers';
import replaceEscapeHtml from '@/app/utils/replaceEscapeHtml';
import { hasImageShopify } from '@/app/utils/replaceImageToSize';
import emitter from '@/emitter';
import { addElement } from '@/modules/gem-meter';
import { app } from '@/store';
import * as Sentry from '@sentry/vue';
import { AtomGroup } from '../editor/iframe/atom/Atom.model';
import { addModuleGroupJquery } from './AtomGroupHelper';
import { arrayFilter, arrayMap } from './nativeArray';

const HELPER = {
  objectToStyle: (style) => {
    return Object.keys(style).reduce(
      (acc, key) =>
        acc +
        key
          .split(/(?=[A-Z])/)
          .join('-')
          .toLowerCase() +
        ':' +
        replaceEscapeHtml(style[key]) +
        ';',
      '',
    );
  },
  removeAllHtmlTag: (body) => {
    if (!body) return '';
    const regex = /(<([^>]+)>)/gi,
      result = body.replace(regex, '');

    return result;
  },
  probably: (percentage) => {
    return Math.random() * 100 < percentage;
  },
  arrayUnique: function (array) {
    if (!array) {
      return [];
    }
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  },
  trim: function (s, c) {
    if (c === ']') c = '\\]';
    if (c === '\\') c = '\\\\';
    return s.replace(new RegExp('^[' + c + ']+|[' + c + ']+$', 'g'), '');
  },
  checkFieldsHideAll: function ($target) {
    const $gfResTool = jQuery('#gfResTool');
    if ($target && $target.length > 0) {
      const $formElements = $target.find(
        '.gfSGSettings > input.field-hide-all, .gfSGSettings > select.field-hide-all, .gfSGSettings > textarea.field-hide-all, .gfSGSettings > span.field-hide-all',
      );
      const size = $gfResTool.data('gfrestool')?.getCurrentStatus();
      for (let i = 0; i < $formElements.length; i++) {
        const $formElement = $($formElements[i]);

        if (typeof $formElement.attr('requires') === 'undefined') {
          // Không phải requies thì mới xem xét ẩn hay không.
          if ($formElement.hasClass('field-hide-all')) {
            if ($formElement.hasClass('field-visible-' + size)) {
              $formElement.next().show();
            } else {
              $formElement.next().hide();
            }
          }
        }
      }
    }
  },
  checkRequires: function ($container, $formElement, isEvent) {
    const $gfResTool = jQuery('#gfResTool');
    if (isEvent == undefined) {
      isEvent = true;
    }
    const _requires = typeof $formElement.attr('requires') !== undefined ? $formElement.attr('requires') : false;
    if (_requires) {
      const listRequire = _requires.split('+');
      for (let k = 0; k < listRequire.length; k++) {
        const require = listRequire[k];
        const arrayRequires = require.split('|');
        const attrId = arrayRequires[0];
        var attrValue = arrayRequires[1];
        // Kiểm tra xem có ở trong group hiện tại không;
        var $dadRequire = $container.find('#' + attrId);
        if ($dadRequire.length > 0) {
          if ($formElement.hasClass('gfDesc')) {
            var $gfField = $formElement;
          } else {
            var $gfField = $formElement.next();
          }
        } else {
          // Không có trong group hiện tại thì lấy ở tất cả Left siderbar
          const $gfLeftSideBar = jQuery('#gfLeftSideBar');
          $dadRequire = jQuery($gfLeftSideBar.find('#' + attrId));
          if ($container.hasClass('columns-advanced')) {
            // field ở advanced
            if ($formElement.hasClass('gfDesc')) {
              var $gfField = $formElement;
            } else {
              var $gfField = $formElement.next();
            }
          } else {
            // Elm
            var $gfField = $container;
          }
        }
        // Nếu là group adv thì không làm gì
        if ($gfField.hasClass('columns-advanced')) {
          continue;
        }
        let hideFieldInit = true;
        const list_require = attrValue.split(':');
        for (let i = 0; i < list_require.length; i++) {
          if ($dadRequire.attr('value') !== list_require[i]) {
          } else {
            // Check columns hide;
            if ($formElement.hasClass('field-hide-all')) {
              const size = $gfResTool.data('gfrestool').getCurrentStatus();
              if ($formElement.hasClass('field-visible-' + size)) {
                hideFieldInit = false;
              }
            } else {
              hideFieldInit = false;
            }
          }
        }
        if (hideFieldInit) {
          $gfField.hide();
          $formElement.trigger('require-hide');
        } else {
          $gfField.show();
          $formElement.trigger('require-show');
        }

        // EVENT SWTICH
        if (isEvent) {
          $dadRequire.on('on-require', function () {
            let hideField = true;

            const list_require = attrValue.split(':');
            for (let i = 0; i < list_require.length; i++) {
              if ($dadRequire.val() == list_require[i]) {
                // Check columns hide;
                if ($formElement.hasClass('field-hide-all')) {
                  const size = $gfResTool.data('gfrestool').getCurrentStatus();
                  if ($formElement.hasClass('field-visible-' + size)) {
                    hideField = false;
                  }
                } else {
                  hideField = false;
                }
              }
            }
            if (hideField) {
              $gfField.hide();
              $formElement.trigger('require-hide');
            } else {
              $gfField.show();
              $formElement.trigger('require-show');
            }
          });
        }
      }
    }
  },
  generatePlaceholderForm: function ($targetElement) {
    if ($targetElement != undefined) {
      const label = $targetElement.attr('data-label');
      let bPl = '<div class="block-placeholder"></div>';

      // if the item is in the `Carousel` module, it is necessary to specify the class `placeholder-carousel` to recognize that `block-placeholder`.
      // Support checking in `updatePlaceHolders()` optimize performance
      if (label == 'Carousel' || $targetElement.closest('.module-wrap').attr('data-label') == 'Carousel') {
        bPl = '<div class="block-placeholder gf_bp--carousel"></div>';
      }

      // Update placeholder
      if (!$targetElement.hasClass('gf_row_no_tools') && !$targetElement.hasClass('gf_col_no_tools')) {
        const $before = $targetElement.prev('.block-placeholder');
        const $after = $targetElement.next('.block-placeholder');

        // Elm no add block placeholder before and after;
        let flagAppend = true;
        switch (label) {
          case 'Popup':
            flagAppend = false;
            break;

          default:
            // product list + article list
            if ($targetElement.parent().hasClass('gf_col_no_tools')) {
              flagAppend = false;
            }
            break;
        }

        if ($before.length == 0 && flagAppend) {
          $targetElement.before(bPl);
        }
        if ($after.length == 0 && flagAppend) {
          $targetElement.after(bPl);
        }

        // Update placeholder when row has no content
        if ($targetElement.hasClass('gf_row')) {
          $targetElement.children('.gf_column').each(function () {
            const $column = jQuery(this);
            const $mer = $column.children('.gf_row, .element-wrap, .module-wrap');
            if ($mer.length == 0) {
              $column.find('.block-placeholder').remove();
              $column.prepend(bPl);
            }
          });
        }

        // Update placeholder when module has no content
        if ($targetElement.hasClass('module-wrap')) {
          $targetElement.find('.item-content').each(function () {
            const $itemContent = jQuery(this);
            if ($itemContent.closest('.module-wrap').is($targetElement)) {
              const $mer = $itemContent.children('.gf_row, .element-wrap, .module-wrap');
              if ($mer.length == 0) {
                $itemContent.prepend(bPl);
              }
            }
          });
        }
      }
    } else {
      // TargetElement undefined
    }
  },
  getFontNameFromString: function (string) {
    let fontName = 'default';
    if (string.split(',').length == 1) {
      const fontArray = string.split(':');
      if (fontArray.length > 1) {
        fontName = fontArray[1].replace('!important', '').replace(';', '');
        fontName = fontName.replace(/"|'/g, '');
        fontName = jQuery.trim(fontName);

        for (let i = 0; i < _pageFonts.length; i++) {
          if (fontName == _pageFonts[i].styleName) {
            fontName = _pageFonts[i].googleName;
            break;
          }
        }
      }
    }
    return fontName;
  },
  addFontLink: function (font, options) {
    const $gfFrameHead = jQuery('#gfFrame').contents().find('head');
    if (options && options.addMultipleFonts) {
      const $fontLink = $gfFrameHead.find('link.gf_fonts');
      const fonts = arrayMap(font, (item) => ({
        font: item,
        imported: false,
      }));
      const fontsLength = fonts.length;

      const $fontLinkLength = $fontLink.length;
      for (let i = 0; i < $fontLinkLength; i++) {
        const $link = $($fontLink[i]);
        const fontData = $link.attr('data-fonts');

        if (fontData) {
          let active = false;
          for (let j = 0; j < fontsLength; j++) {
            const item = fonts[j];
            if (item.font == fontData) {
              active = true;
              item.imported = true;
              break;
            }
          }

          if (!active) {
            $link.remove();
          }
        }
      }

      const links = arrayFilter(
        fonts,
        (item) => !item.imported,
        (item) => `
        <link
          class="gf_fonts"
          data-fonts="${item.font}"
          href="https://fonts.googleapis.com/css2?family=${item.font}:wght@100;200;300;400;500;600;700;800;900&display=swap"
          rel="stylesheet" type="text/css"
        />`,
      );

      $gfFrameHead.append(links.join(''));
      return;
    }

    const _defaultFonts = [
      {
        googleName: 'ABeeZee',
        styleName: 'ABeeZee',
        fontWeight: '400',
      },
      {
        googleName: 'Abril+Fatface',
        styleName: 'Abril Fatface',
        fontWeight: '400',
      },
      {
        googleName: 'Acme',
        styleName: 'Acme',
        fontWeight: '400',
      },
      {
        googleName: 'Alegreya:400,700',
        styleName: 'Alegreya',
        fontWeight: '400',
      },
      {
        googleName: 'Alegreya+Sans:400,700',
        styleName: 'Alegreya Sans',
        fontWeight: '400',
      },
      {
        googleName: 'Anton',
        styleName: 'Anton',
        fontWeight: '400',
      },
      {
        googleName: 'Arimo:400,700',
        styleName: 'Arimo',
        fontWeight: '400',
      },
      {
        googleName: 'Arizonia',
        styleName: 'Arizonia',
        fontWeight: '400',
      },
      {
        googleName: 'Arvo:400,700',
        styleName: 'Arvo',
        fontWeight: '400',
      },
      {
        googleName: 'Baloo+Bhaina',
        styleName: 'Baloo Bhaina',
        fontWeight: '400',
      },
      {
        googleName: 'Bitter:400,700',
        styleName: 'Bitter',
        fontWeight: '400',
      },
      {
        googleName: 'Cabin:400,700',
        styleName: 'Cabin',
        fontWeight: '400',
      },
      {
        googleName: 'Cherry+Swash:400,700',
        styleName: 'Cherry Swash',
        fontWeight: '400',
      },
      {
        googleName: 'Courgette',
        styleName: 'Courgette',
        fontWeight: '400',
      },
      {
        googleName: 'Crimson+Text:400,700',
        styleName: 'Crimson Text',
        fontWeight: '400',
      },
      {
        googleName: 'Diplomata+SC',
        styleName: 'Diplomata SC',
        fontWeight: '400',
      },
      {
        googleName: 'Domine:400,700',
        styleName: 'Domine',
        fontWeight: '400',
      },
      {
        googleName: 'Dosis:400,700',
        styleName: 'Dosis',
        fontWeight: '400',
      },
      {
        googleName: 'Exo:400,700',
        styleName: 'Exo',
        fontWeight: '400',
      },
      {
        googleName: 'Fira+Sans:400,700',
        styleName: 'Fira Sans',
        fontWeight: '400',
      },
      {
        googleName: 'Fjalla+One',
        styleName: 'Fjalla One',
        fontWeight: '400',
      },
      {
        googleName: 'Gentium+Basic:400,700',
        styleName: 'Gentium Basic',
        fontWeight: '400',
      },
      {
        googleName: 'Grand+Hotel',
        styleName: 'Grand Hotel',
        fontWeight: '400',
      },
      {
        googleName: 'Gravitas+One',
        styleName: 'Gravitas One',
        fontWeight: '400',
      },
      {
        googleName: 'Inconsolata:400,700',
        styleName: 'Inconsolata',
        fontWeight: '400',
      },
      {
        googleName: 'Indie+Flower',
        styleName: 'Indie Flower',
        fontWeight: '400',
      },
      {
        googleName: 'Josefin+Sans:400,700',
        styleName: 'Josefin Sans',
        fontWeight: '400',
      },
      {
        googleName: 'Karla:400,700',
        styleName: 'Karla',
        fontWeight: '400',
      },
      {
        googleName: 'Kreon:400,700',
        styleName: 'Kreon',
        fontWeight: '400',
      },
      {
        googleName: 'Krona+One',
        styleName: 'Krona One',
        fontWeight: '400',
      },
      {
        googleName: 'Lato:400,700',
        styleName: 'Lato',
        fontWeight: '400',
      },
      {
        googleName: 'League+Script',
        styleName: 'League Script',
        fontWeight: '400',
      },
      {
        googleName: 'Libre+Baskerville:400,700',
        styleName: 'Libre Baskerville',
        fontWeight: '400',
      },
      {
        googleName: 'Libre+Franklin:400,700',
        styleName: 'Libre Franklin',
        fontWeight: '400',
      },
      {
        googleName: 'Lobster',
        styleName: 'Lobster',
        fontWeight: '400',
      },
      {
        googleName: 'Lora:400,700',
        styleName: 'Lora',
        fontWeight: '400',
      },
      {
        googleName: 'Luckiest+Guy',
        styleName: 'Luckiest Guy',
        fontWeight: '400',
      },
      {
        googleName: 'Merriweather:400,700',
        styleName: 'Merriweather',
        fontWeight: '400',
      },
      {
        googleName: 'Montserrat:400,700',
        styleName: 'Montserrat',
        fontWeight: '400',
      },
      {
        googleName: 'Mrs+Sheppards',
        styleName: 'Mrs Sheppards',
        fontWeight: '400',
      },
      {
        googleName: 'Neuton:400,700',
        styleName: 'Neuton',
        fontWeight: '400',
      },
      {
        googleName: 'Niconne',
        styleName: 'Niconne',
        fontWeight: '400',
      },
      {
        googleName: 'Noto+Sans:400,700',
        styleName: 'Noto Sans',
        fontWeight: '400',
      },
      {
        googleName: 'Nunito:400,700',
        styleName: 'Nunito',
        fontWeight: '400',
      },
      {
        googleName: 'Open+Sans:400,700',
        styleName: 'Open Sans',
        fontWeight: '400',
      },
      {
        googleName: 'Oswald:400,700',
        styleName: 'Oswald',
        fontWeight: '400',
      },
      {
        googleName: 'Oxygen:400,700',
        styleName: 'Oxygen',
        fontWeight: '400',
      },
      {
        googleName: 'Pacifico',
        styleName: 'Pacifico',
        fontWeight: '400',
      },
      {
        googleName: 'Paytone+One',
        styleName: 'Paytone One',
        fontWeight: '400',
      },
      {
        googleName: 'Playball',
        styleName: 'Playball',
        fontWeight: '400',
      },
      {
        googleName: 'Playfair+Display:400,700',
        styleName: 'Playfair Display',
        fontWeight: '400',
      },
      {
        googleName: 'Poppins:400,700',
        styleName: 'Poppins',
        fontWeight: '400',
      },
      {
        googleName: 'PT+Mono',
        styleName: 'PT Mono',
        fontWeight: '400',
      },
      {
        googleName: 'PT+Sans:400,700',
        styleName: 'PT Sans',
        fontWeight: '400',
      },
      {
        googleName: 'PT+Serif:400,700',
        styleName: 'PT Serif',
        fontWeight: '400',
      },
      {
        googleName: 'Quattrocento+Sans:400,700',
        styleName: 'Quattrocento Sans',
        fontWeight: '400',
      },
      {
        googleName: 'Qwigley',
        styleName: 'Qwigley',
        fontWeight: '400',
      },
      {
        googleName: 'Raleway:400,700',
        styleName: 'Raleway',
        fontWeight: '400',
      },
      {
        googleName: 'Roboto:400,700',
        styleName: 'Roboto',
        fontWeight: '400',
      },
      {
        googleName: 'Roboto+Condensed:400,700',
        styleName: 'Roboto Condensed',
        fontWeight: '400',
      },
      {
        googleName: 'Roboto+Slab:400,700',
        styleName: 'Roboto Slab',
        fontWeight: '400',
      },
      {
        googleName: 'Rokkitt:400,700',
        styleName: 'Rokkitt',
        fontWeight: '400',
      },
      {
        googleName: 'Sacramento',
        styleName: 'Sacramento',
        fontWeight: '400',
      },
      {
        googleName: 'Sail',
        styleName: 'Sail',
        fontWeight: '400',
      },
      {
        googleName: 'Sedgwick+Ave+Display',
        styleName: 'Sedgwick Ave Display',
        fontWeight: '400',
      },
      {
        googleName: 'Shadows+Into+Light',
        styleName: 'Shadows Into Light',
        fontWeight: '400',
      },
      {
        googleName: 'Sigmar+One',
        styleName: 'Sigmar One',
        fontWeight: '400',
      },
      {
        googleName: 'Six+Caps',
        styleName: 'Six Caps',
        fontWeight: '400',
      },
      {
        googleName: 'Slabo+27px',
        styleName: 'Slabo 27px',
        fontWeight: '400',
      },
      {
        googleName: 'Source+Code+Pro:400,700',
        styleName: 'Source Code Pro',
        fontWeight: '400',
      },
      {
        googleName: 'Stalemate',
        styleName: 'Stalemate',
        fontWeight: '400',
      },
      {
        googleName: 'Titillium+Web:400,700',
        styleName: 'Titillium Web',
        fontWeight: '400',
      },
      {
        googleName: 'Tulpen+One',
        styleName: 'Tulpen One',
        fontWeight: '400',
      },
      {
        googleName: 'Ubuntu:400,700',
        styleName: 'Ubuntu',
        fontWeight: '400',
      },
      {
        googleName: 'Ultra',
        styleName: 'Ultra',
        fontWeight: '400',
      },
      {
        googleName: 'Unica+One',
        styleName: 'Unica One',
        fontWeight: '400',
      },
      {
        googleName: 'Vollkorn:400,700',
        styleName: 'Vollkorn',
        fontWeight: '400',
      },
      {
        googleName: 'Work+Sans:400,700',
        styleName: 'Work Sans',
        fontWeight: '400',
      },
      {
        googleName: 'Yellowtail',
        styleName: 'Yellowtail',
        fontWeight: '400',
      },
    ];
    const _oldFont = [
      'Aclonica',
      'Allan',
      'Annie+Use+Your+Telescope',
      'Anonymous+Pro',
      'Allerta+Stencil',
      'Allerta',
      'Amaranth',
      'Anton',
      'Architects+Daughter',
      'Arimo',
      'Artifika',
      'Arvo',
      'Asset',
      'Astloch',
      'Bangers',
      'Bentham',
      'Bevan',
      'Bigshot+One',
      'Bowlby+One',
      'Bowlby+One+SC',
      'Brawler',
      'Buda:300',
      'Cabin',
      'Calligraffitti',
      'Candal',
      'Cantarell',
      'Cardo',
      'Carter One',
      'Caudex',
      'Cedarville+Cursive',
      'Cherry+Cream+Soda',
      'Chewy',
      'Coda',
      'Coming+Soon',
      'Copse',
      'Corben',
      'Cousine',
      'Covered+By+Your+Grace',
      'Crafty+Girls',
      'Crimson+Text',
      'Crushed',
      'Cuprum',
      'Damion',
      'Dancing+Script',
      'Dawning+of+a+New+Day',
      'Didact+Gothic',
      'Droid+Sans',
      'Droid+Sans+Mono',
      'Droid+Serif',
      'EB+Garamond',
      'Expletus+Sans',
      'Fontdiner+Swanky',
      'Forum',
      'Francois+One',
      'Geo',
      'Give+You+Glory',
      'Goblin+One',
      'Gravitas+One',
      'Gruppo',
      'Hammersmith+One',
      'Holtwood+One+SC',
      'Homemade+Apple',
      'Inconsolata',
      'Indie+Flower',
      'IM+Fell+DW+Pica',
      'IM+Fell+DW+Pica+SC',
      'IM+Fell+Double+Pica',
      'IM+Fell+Double+Pica+SC',
      'IM+Fell+English',
      'IM+Fell+English+SC',
      'IM+Fell+French+Canon',
      'IM+Fell+French+Canon+SC',
      'IM+Fell+Great+Primer',
      'IM+Fell+Great+Primer+SC',
      'Irish+Grover',
      'Irish+Growler',
      'Istok+Web',
      'Josefin+Sans',
      'Josefin+Slab',
      'Judson',
      'Jura',
      'Just+Another+Hand',
      'Just+Me+Again+Down+Here',
      'Kameron',
      'Kenia',
      'Kranky',
      'Kreon',
      'Kristi',
      'La+Belle+Aurore',
      'Lato',
      'League+Script',
      'Lekton',
      'Limelight',
      'Lobster',
      'Lobster Two',
      'Lora',
      'Love+Ya+Like+A+Sister',
      'Loved+by+the+King',
      'Luckiest+Guy',
      'Maiden+Orange',
      'Mako',
      'Maven+Pro',
      'Meddon',
      'MedievalSharp',
      'Megrim',
      'Merriweather',
      'Metrophobic',
      'Michroma',
      'Miltonian Tattoo',
      'Miltonian',
      'Modern Antiqua',
      'Molengo',
      'Mountains of Christmas',
      'Muli',
      'Neucha',
      'Neuton',
      'News+Cycle',
      'Nixie+One',
      'Nobile',
      'Nova+Cut',
      'Nova+Flat',
      'Nova+Mono',
      'Nova+Oval',
      'Nova+Round',
      'Nova+Script',
      'Nova+Slim',
      'Nova+Square',
      'Nunito',
      'OFL+Sorts+Mill+Goudy+TT',
      'Old+Standard+TT',
      'Open+Sans',
      'Open+Sans+Condensed:300',
      'Orbitron',
      'Oswald',
      'Over+the+Rainbow',
      'Reenie+Beanie',
      'Pacifico',
      'Parisienne',
      'Patrick+Hand',
      'Paytone+One',
      'Permanent+Marker',
      'Philosopher',
      'Play',
      'Playfair+Display',
      'Podkova',
      'PT+Sans',
      'PT+Sans+Narrow',
      'PT+Serif',
      'PT+Serif Caption',
      'Puritan',
      'Quattrocento',
      'Quattrocento+Sans',
      'Radley',
      'Raleway:100',
      'Redressed',
      'Rock+Salt',
      'Roboto',
      'Rokkitt',
      'Ruslan+Display',
      'Schoolbell',
      'Shadows+Into+Light',
      'Shanti',
      'Sigmar+One',
      'Six+Caps',
      'Slackey',
      'Smythe',
      'Sniglet:800',
      'Special+Elite',
      'Stardos+Stencil',
      'Sue+Ellen+Francisco',
      'Sunshiney',
      'Swanky+and+Moo+Moo',
      'Syncopate',
      'Tangerine',
      'Tenor+Sans',
      'Terminal+Dosis+Light',
      'The+Girl+Next+Door',
      'Tinos',
      'Ubuntu',
      'Ultra',
      'Unkempt',
      'UnifrakturCook:bold',
      'UnifrakturMaguntia',
      'Varela',
      'Varela Round',
      'Vibur',
      'Vollkorn',
      'VT323',
      'Waiting+for+the+Sunrise',
      'Wallpoet',
      'Walter+Turncoat',
      'Wire+One',
      'Yanone+Kaffeesatz',
      'Yeseva+One',
      'Zeyada',
    ];
    let count = 0;
    let fontFamily = font;
    if (font) {
      if (font.toLowerCase() != 'inherit' && font.toLowerCase() != 'default') {
        const fontName = font.indexOf(':') >= 0 ? font.split(':')[0] : font;
        // replaceAll not using on IE
        const styleName = fontName.replaceAll('+', ' ');
        for (var i = 0; i < _defaultFonts.length; i++) {
          if (styleName == _defaultFonts[i].styleName) {
            fontFamily = _defaultFonts[i].googleName;
            count++;
          }
        }
        if (count == 0) {
          for (var i = 0; i < _oldFont.length; i++) {
            if (font == _oldFont[i]) {
              count++;
            }
          }
        }
      }
      if (count > 0) {
        const link = `//fonts.googleapis.com/css?family=${fontFamily}`;
        if ($gfFrameHead.find(`link[data-fonts="${fontFamily}"]`).length == 0) {
          $gfFrameHead.append(
            `<link class="gf_fonts" data-fonts="${fontFamily}" href="${link}" rel="stylesheet" type="text/css" />`,
          );
        }
      }
    }
    return font;
  },
  replaceFields: function (fields, templateTmp) {
    jQuery.each(fields, function (index, field) {
      let regex = '';

      if (field.hasOwnProperty('default_value')) {
        const name = field.name;
        const value = field.default_value;

        // nice regex
        regex = transformRegexvalue(name);
        if (templateTmp.match(regex)) {
          const matched = templateTmp.match(regex)[0];
          const matchedString = new RegExp(matched, 'g');

          templateTmp = templateTmp.replace(matchedString, value);
        }
      }

      if (field.type != undefined && field.type == 'group' && field.items && field.items.length) {
        for (var i = 0; i < field.items.length; i++) {
          const nameGro = field.items[i].name;
          const valueGro = field.items[i].default_value;

          // nice regex
          regex = transformRegexvalue(nameGro);
          if (templateTmp.match(regex)) {
            const matchedGro = templateTmp.match(regex)[0];
            const matchedStringGro = new RegExp(matchedGro, 'g');

            templateTmp = templateTmp.replace(matchedStringGro, valueGro);
          }
        }
      }

      if (field.advanced != undefined && field.advanced.length > 0) {
        for (var i = 0; i < field.advanced.length; i++) {
          const nameAdv = field.advanced[i].name;
          const valueAdv = field.advanced[i].default_value;

          // nice regex
          regex = transformRegexvalue(nameAdv);
          if (templateTmp.match(regex)) {
            const matchedAdv = templateTmp.match(regex)[0];
            const matchedStringAdv = new RegExp(matchedAdv, 'g');

            templateTmp = templateTmp.replace(matchedStringAdv, valueAdv);
          }
        }
      }
    });
    return templateTmp;
  },
  base64UrlEncode: function (input) {
    const charMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    const str = String(input);
    let map = charMap;
    let block = 0,
      output = '';
    const prx = [2, 4, 6, 8];
    for (
      var code, idx = 3 / 4, uarr;
      !isNaN((code = str.charCodeAt(idx))) || 63 & block || ((map = '='), (idx - 3 / 4) % 1);
      idx += 3 / 4
    ) {
      if (code > 0x7f) {
        (uarr = encodeURI(str.charAt(idx)).split('%')).shift();
        for (var hex, idx2 = idx % 1; (hex = uarr[idx2 | 0]); idx2 += 3 / 4) {
          block = (block << 8) | parseInt(hex, 16);
          output += map.charAt(63 & (block >> (8 - (idx2 % 1) * 8)));
        }
        idx = idx === 3 / 4 ? 0 : idx;
        idx += ((3 / 4) * uarr.length) % 1;
      } else {
        block = (block << 8) | code;
        output += map.charAt(63 & (block >> (8 - (idx % 1) * 8)));
      }
    }
    return output;
  },
  base64UrlDecode: function (input) {
    const charMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let str = String(input),
      map = charMap.slice(0, -1),
      prx = [6, 4, 2, 0],
      output = '',
      block = 0,
      code,
      buffer = 0,
      hex = '';
    try {
      for (let i = 0; (code = map.indexOf(str[i])) > -1; i++) {
        block = (block << 6) | code;
        if (i % 4) {
          buffer = 255 & (block >> prx[i % 4]);
          if (buffer < 128) {
            output += hex ? decodeURI(hex) : '';
            output += String.fromCharCode(buffer);
            hex = '';
          } else {
            hex += '%' + ('0' + buffer.toString(16)).slice(-2);
          }
        }
      }
      output += hex ? decodeURI(hex) : '';
      return output;
    } catch (err) {
      // Base64 malformed
    }
  },
  toHandle: function (text) {
    return text
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/(;|\/|\?|:|@|=|&|"|'|<|>|#|%|{|}|\||\\|^|~|\[|\]|`)+/g, '');
  },
  getResponsiveAlign: function ($elm, screenType, format) {
    if (format == undefined) {
      format = 'gf-elm';
    }
    let align = 'left';
    if ($elm.hasClass(format + '-center-' + screenType)) {
      align = 'center';
    } else if ($elm.hasClass(format + '-left-' + screenType)) {
      align = 'left';
    } else if ($elm.hasClass(format + '-right-' + screenType)) {
      align = 'right';
    } else if ($elm.hasClass(format + '-justify-' + screenType)) {
      align = 'justify';
    } else {
      if ($elm.hasClass(format + '-center')) {
        align = 'center';
      } else if ($elm.hasClass(format + '-left')) {
        align = 'left';
      } else if ($elm.hasClass(format + '-right')) {
        align = 'right';
      } else if ($elm.hasClass(format + '-justify')) {
        align = 'justify';
      }
    }
    return align;
  },
  setResponsiveAlign: function (align, $elm, screenType, format) {
    if (format == undefined) {
      format = 'gf-elm';
    }
    $elm.removeClass(format + '-left-' + screenType);
    $elm.removeClass(format + '-center-' + screenType);
    $elm.removeClass(format + '-right-' + screenType);
    $elm.removeClass(format + '-justify-' + screenType);
    $elm.addClass(format + '-' + align + '-' + screenType);
    if (screenType == 'lg') {
      const devices = ['md', 'sm', 'xs'];

      for (var k = 0; k < devices.length; k++) {
        var screenT = devices[k];

        if (
          !$elm.hasClass(format + '-left-' + screenT) &&
          !$elm.hasClass(format + '-center-' + screenT) &&
          !$elm.hasClass(format + '-right-' + screenT) &&
          !$elm.hasClass(format + '-justify-' + screenT)
        ) {
          window._isCSSOverWrite['align-' + screenT] = true;
        }
      }

      for (var k = 0; k < devices.length; k++) {
        var screenT = devices[k];

        if (window._isCSSOverWrite['align-' + screenT]) {
          $elm.removeClass(format + '-left-' + screenT);
          $elm.removeClass(format + '-center-' + screenT);
          $elm.removeClass(format + '-right-' + screenT);
          $elm.removeClass(format + '-justify-' + screenT);
          $elm.addClass(format + '-' + align + '-' + screenT);
        }
      }
    }
    return false;
  },
  getImageSmall: function (image, size) {
    if (!image) return '';

    // Src images
    const arrImage = image.split('?')[0].split('/').pop();
    const slugName = arrImage.split('.');
    const strExtention = slugName.pop();
    let nameImages = '';
    for (let h = 0; h < slugName.length; h++) {
      nameImages += slugName[h] + '.';
    }
    nameImages = nameImages.substr(0, nameImages.length - 1);

    const srcImageSplit = image.split('?')[0].split('/');
    let smallSrc = '';
    for (let j = 0; j < srcImageSplit.length - 1; j++) {
      smallSrc += srcImageSplit[j] + '/';
    }
    smallSrc += nameImages + '_' + size.width + 'x' + size.height + '.' + strExtention;

    return smallSrc;
  },

  isPopupOpened: function () {
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $popupAnchorList = $gryffBody.find('.gf-popupAnchorList');
    if ($popupAnchorList.find('.gf-popupAnchor:visible:not(.gf-popupOff)').length > 0) {
      return true;
    }
    return false;
  },

  // Validate
  isEmail: function (email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  // Ukpd4as
  MakeId: function () {
    return Math.round(new Date().getTime() + Math.random() * 100 + Math.random() * 100);
  },
  isInsideTheList: function ($element) {
    if ($element != undefined) {
      if (
        ($element.closest('[data-label="Product List"]').length > 0 &&
          $element.closest('[data-label="Product"]').length > 0) ||
        ($element.closest('[data-label="Related Products"]').length > 0 &&
          $element.closest('[data-label="Product"]').length > 0) ||
        ($element.closest('[data-label="Article List"]').length > 0 &&
          $element.closest('[data-label="Article"]').length > 0)
      ) {
        return true;
      }
    }
    return false;
  },
  MakeIdInsideList: function ($element, type, increase) {
    let eId = '';

    if (HELPER.isInsideTheList($element)) {
      eId = $element.attr('data-id');
      if (eId == undefined || !eId.match('child') || type == 'new') {
        if ($element.closest('[data-label="Product"]').length > 0) {
          var $module = $element.closest('[data-label="Product"]');
        } else if ($element.closest('[data-label="Article"]').length > 0) {
          var $module = $element.closest('[data-label="Article"]');
        }

        const mId = $module.attr('data-id') || HELPER.MakeId();
        let min = 0;
        $module.find('[data-id]').each(function () {
          const id = jQuery(this).attr('data-id');
          if (id.match('child')) {
            const lastString = id.split('child')[1];
            if (lastString.match('-')) {
              const count = parseInt(lastString.split('-')[1]);
              if (min < count) {
                min = count;
              }
            }
          }
        });

        if (increase == undefined) {
          increase = 1;
        }
        min = min + increase;

        if ($element.parent().closest('[data-label="Tabs"]').length > 0) {
          const index = $element.closest('.item-content[data-index]').attr('data-index') || 0;
          eId = mId + '-' + min + '-' + index;
        } else {
          eId = mId + '-' + min;
        }
      }
    }
    return eId;
  },
  showNotify: function (msg, type, duration, zIndex) {
    const $notifiBar = jQuery('#notifiBar');
    const settings = {
      msg: msg,
      type: type,
    };
    if (duration != undefined) {
      settings['duration'] = duration;
    }
    if (zIndex != undefined) {
      settings['zIndex'] = zIndex;
    }
    $notifiBar.data('notifibar').showNotifi(settings);
    return false;
  },
  updateRelatedListInList: function (relatedListData) {
    const _relatedListArray = store.getValue('__RelatedProduct');
    let found = false;
    for (let i = 0; i < _relatedListArray.length; i++) {
      const pid = _relatedListArray[i].pid == 0 ? 'auto' : _relatedListArray[i].pid;
      const plimit = parseInt(_relatedListArray[i].limit);
      const pexcludes = _relatedListArray[i].excludes;

      if (pid.toString() == relatedListData['pid'].toString() && pexcludes == relatedListData['excludes']) {
        if (plimit <= parseInt(relatedListData['limit'])) {
          _relatedListArray[i] = relatedListData;
          found = true;
          break;
        }
        break;
      }
    }
    if (!found) {
      _relatedListArray.push(relatedListData);
    }
    return relatedListData;
  },
  saveSnippetCategories: function (cats) {
    window.gfSnippetCategories = cats;
    return true;
  },

  getSnippetCategories: function () {
    return window.gfSnippetCategories || null;
  },
  searchRelatedListInList: function (productId, limit, excludes) {
    const _relatedListArray = store.getValue('__RelatedProduct');
    let relatedListData = {};
    for (let i = 0; i < _relatedListArray.length; i++) {
      const pid = _relatedListArray[i].pid == 0 ? 'auto' : _relatedListArray[i].pid;
      const plimit = parseInt(_relatedListArray[i].limit);
      const pexcludes = _relatedListArray[i].excludes;

      if (productId.toString() == pid.toString() && parseInt(limit) <= plimit && excludes == pexcludes) {
        relatedListData = _relatedListArray[i];
        break;
      }
    }
    return relatedListData;
  },
  updateProductListInList: function (productListData) {
    let found = false;
    for (let i = 0; i < window._productListArray.length; i++) {
      const cid = window._productListArray[i].cid == 0 ? 'auto' : window._productListArray[i].cid;
      const climit = parseInt(window._productListArray[i].limit);
      if (cid && productListData['cid'] && cid.toString() == productListData['cid'].toString()) {
        if (climit <= parseInt(productListData['limit'])) {
          window._productListArray[i] = productListData;
          found = true;
          break;
        }
        break;
      }
    }
    if (!found) {
      window._productListArray.push(productListData);
    }
    return productListData;
  },
  searchProductListInList: function (collectionId, limit) {
    let productListData = {};

    for (let i = 0; i < window._productListArray.length; i++) {
      const cid = window._productListArray[i].cid == 0 ? 'auto' : window._productListArray[i].cid;
      const climit = parseInt(window._productListArray[i].limit);

      // COLLECTION 2019
      if (cid && collectionId.toString() == cid.toString() && parseInt(limit) <= climit) {
        productListData = window._productListArray[i];
        break;
      }
    }
    return productListData;
  },
  updateProductInList: function (productData) {
    const array = [];
    if (window._productArray && window._productArray.length) {
      for (let i = 0; i < window._productArray.length; i++) {
        // Check nếu productData chưa tồn tại trong window._productArray thì sẽ push lại data trong window._productArray
        // code cũ nên chưa refactor do dùng nhiều window._productArray
        if (window._productArray[i].id !== productData.id) {
          array.push(window._productArray[i]);
        }
      }
    }
    // Push new product data to list
    array.push(productData);

    window._productArray = array;

    return productData;
  },

  /**
   * Function này sẽ update product mới với id tương ứng
   * @param productData
   * @returns {*}
   */
  updateDetailProduct: function (productData) {
    if (window._productArray && window._productArray.length) {
      const pSize = window._productArray.length;
      for (let i = 0; i < pSize; i++) {
        if (window._productArray[i].id === productData.id) {
          window._productArray[i] = productData;
        }
      }
    }
  },

  // COLLECTION 2019
  updateCollectionInList: function (collection) {
    const array = [];
    if (window._collectionArray == undefined) {
      window._collectionArray = [];
    }

    for (let i = 0; i < window._collectionArray.length; i++) {
      if (window._collectionArray[i].id !== collection.id) {
        array.push(window._collectionArray[i]);
      }
    }
    array.push(collection);

    window._collectionArray = array;

    return collection;
  },

  searchProductInList: function (productId) {
    let productData = {};

    try {
      if (
        productId === 'auto' &&
        window._productLatest &&
        typeof window._productLatest === 'object' &&
        Object.keys(window._productLatest).length > 0
      ) {
        return window._productLatest;
      }

      if (Array.isArray(window._productArray) && window._productArray.length > 0) {
        for (let i = 0; i < window._productArray.length; i++) {
          if (
            window._productArray[i].id == productId ||
            (productId === 'auto' && window._productArray[i].latest_product)
          ) {
            productData = window._productArray[i];
            break;
          }
        }
      }
    } catch (error) {
      console.error('TypeError searchProductInList:', error);
    }

    return productData;
  },

  searchProductInListV2: function (productId) {
    let productData = {};
    const latestProduct = getProductLatest();

    // Nếu productId là auto thì return luôn không cần chạy tiếp để tìm trong mảng _productArray nữa
    const latestProductResult = latestProduct?.product;
    if (productId === 'auto' && latestProductResult) {
      return latestProductResult;
    }

    // Convert productId to number to compared with id in array
    productId = parseInt(productId);

    const productArraySize = window._productArray.length;
    if (window._productArray && productArraySize) {
      for (let i = 0; i < productArraySize; i++) {
        if (window._productArray[i].id === productId) {
          productData = window._productArray[i];
          break;
        }
      }
    }
    return productData;
  },

  // COLLECTION 2019
  searchCollectionInList: function (collectionId) {
    let collectionData = {};
    if (window._collectionArray == undefined) {
      window._collectionArray = [];
      return collectionData;
    }

    for (let i = 0; i < window._collectionArray.length; i++) {
      if (window._collectionArray[i].id == collectionId) {
        collectionData = window._collectionArray[i];
        break;
      }
    }
    return collectionData;
  },

  getNewestProducts: async function (callback, limit) {
    if (!limit) {
      limit = 30;
    }
    // for search
    const $gfFrame = jQuery('#gfFrame');
    let _productNewestArray = [];
    if (_productNewestArray.length == 0) {
      const shop = $gfFrame.data('gfframe').getShopDomain();
      const req = api.getProducts();
      try {
        const data = {
          shop: shop,
          limit: limit,
          fields: 'id,title,handle,status',
          isDashboard: true,
        };
        const res = await GET(api.getProducts().url, data);
        const jsonData = res.data;
        _productNewestArray = jsonData;
        callback(_productNewestArray);
      } catch (error) {
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
        $productList && $productList.css('opacity', '1');
      }
    } else {
      callback(_productNewestArray);
    }
    return false;
  },
  getSwatchesOptions: async function (callback) {
    if (window.gfSwatchesOptionData) {
      return window.gfSwatchesOptionData;
    }
    const $gfFrame = getGlobalVariable('gfFrame');
    const shop = $gfFrame.data('gfframe').getShopDomain();
    const collectionId = 'auto';
    const limit = 250;

    const data = {
      shop: shop,
      collectionId: collectionId,
      limit: limit,
    };

    const swatchesData = {};

    try {
      const res = await GET(api.getProducts().url, data);
      const jsonData = res.data;
      const productlistObject = {
        cid: collectionId,
        limit: limit,
        list: jsonData.products,
      };
      HELPER.updateProductListInList(productlistObject);

      const productLength = jsonData.products.length;
      for (let i = 0; i < productLength; i++) {
        const productData = jsonData.products[i];

        // check the nay de uu tien khi load san pham no update variant.available
        const data = HELPER.searchProductInList(productData.id);
        if (jQuery.isEmptyObject(data)) {
          HELPER.updateProductInList(productData);
        }

        if (productData.options) {
          const optionLength = productData.options.length;
          for (let j = 0; j < optionLength; j++) {
            const name = productData.options[j].name;
            const values = productData.options[j].values;
            if (name && values) {
              if (!swatchesData[name]) {
                swatchesData[name] = [];
              }
              const valuesLength = values.length;
              for (let k = 0; k < valuesLength; k++) {
                if (swatchesData[name].indexOf(values[k]) == -1) {
                  swatchesData[name].push(values[k]);
                }
              }
            }
          }
        }
      }

      window.gfSwatchesOptionData = swatchesData;
      return swatchesData;
    } catch (err) {
      HELPER.showNotify('There are some errors occurred please try again.', 'error');
      console.log(err);

      return swatchesData;
    }
  },

  getlistIcons: async function (callback) {
    let _listIcons = window._listIcons;
    if (!_listIcons || _listIcons.length == 0) {
      try {
        const res = await GET(api.getlistIcons().url, { limit: 1250 });
        _listIcons = res.data;
        window._listIcons = _listIcons;
        callback(_listIcons);
      } catch (error) {
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
      }
    } else {
      callback(_listIcons);
    }
    return false;
  },

  simpleEscape: function (str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  },
  simpleHTMLEntities: function (str) {
    return String(str).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  },
  capitalizeFirstLetter: function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  designOptionsForCSS: function (style, cssOfObject, attr, value, regex, overWrite) {
    if (overWrite == undefined) {
      overWrite = true;
    }
    let append = '';
    let newCss = cssOfObject;
    let line = '';

    if (value != '' && value != undefined) {
      switch (attr) {
        case 'background-v2': // Mốc switch color and images
          break;
        case 'color':
        case 'background-color':
        case 'border-color':
          line = attr + ': ' + value + '!important;';
          break;

        case 'font-family':
          if (value && value.toLowerCase() != 'inherit') {
            //thêm nháy đơn cho font family vì trường hợp Custom Font có khoảng trống (hỗ trợ custom font từ ES)
            line = attr + ": '" + value + "'!important;";
          }
          break;

        case 'border-top-width':
        case 'border-right-width':
        case 'border-bottom-width':
        case 'border-left-width':
          line = attr + ': ' + value + '!important;';
          break;

        case 'border-style':
        case 'background-size':
        case 'background-repeat':
        case 'background-position':
          line = attr + ': ' + value + '!important;';
          break;

        case 'display':
          if (value == 'none') {
            line = attr + ': none!important;';
          } else {
            line = '';
          }
          break;

        case 'box-shadow':
          if (value && value.type && value.type != 'inset') {
            value.type = '';
          }
          var val =
            value.x +
            'px ' +
            value.y +
            'px ' +
            value.blur +
            'px ' +
            value.spread +
            'px ' +
            value.color +
            ' ' +
            value.type;
          line = attr + ': ' + val + '!important;';
          break;

        default:
          line = attr + ': ' + value + '!important;';
          break;
      }
      var matchedString = new RegExp('(.?\\s)' + attr + '.*?;', 'g');
      if (cssOfObject.match(matchedString)) {
        if (overWrite) {
          newCss = newCss.replace(matchedString, line);
        }
      } else {
        append += '\n\t' + line;
      }
      append += '\n}';
      newCss = newCss.replace('}', append);
    } else {
      var matchedString = new RegExp('(.?\\s)' + attr + '.*?;', 'g');
      if (cssOfObject.match(matchedString)) {
        newCss = newCss.replace(matchedString, line);
      }
    }
    newCss = HELPER.formatCSS(newCss);
    style = HELPER.formatCSS(style);

    if (style.match(regex)) {
      const object = style.match(regex)[0];
      style = style.replace(object, newCss);
    }
    // Disable với case cùng targetClass nhưng khá value color:{red}; color:{text-align:center}
    // if (style.match(regex)) {
    //   const matches = style.match(regex);
    //   for (let i = 0; i < matches.length; i++) {
    //     const object = matches[i];
    //     if (i == 0) {
    //       style = style.replace(object, newCss);
    //     } else {
    //       // Nếu trong css có 2 targetClass thì từ những dòng thứ 2 sẽ bị xoá đi
    //       style = style.replace(object, '');
    //     }
    //   }
    // }

    return style;
  },
  setValueFromCSS: function ($targetElement, style, attr, value, screenType, tgrClass, overWrite) {
    const _xsRegexWindow = /@media(.*)width(.*)767.2px[^{]+\{([\s\S]+?})\s*}/g;
    const _xsRegex = /@media(.*)max-width(.*)767px[^{]+\{([\s\S]+?})\s*}/g;
    const _smRegex = /@media(.*)max-width(.*)991px(.*)and(.*)min-width(.*)768px[^{]+\{([\s\S]+?})\s*}/g;
    const _mdRegex = /@media(.*)max-width(.*)1199px(.*)and(.*)min-width(.*)992px[^{]+\{([\s\S]+?})\s*}/g;
    const _lgRegex = /@media(.*)min-width(.*)1200px[^{]+\{([\s\S]+?})\s*}/g;
    // generate @media if not exised
    if ($targetElement != undefined) {
      if (overWrite == undefined) {
        overWrite = true;
      }
      let wrapRegex = '';
      let targetRegex = '';
      const idRegex = '';
      let targetClass = tgrClass;
      let id = '';

      if ($targetElement.hasClass('gf_row')) {
        // wrapRegex = targetRegex = /#r-[^\s]+(\S*\s+)?{(.|\n)*?\}/g
        wrapRegex = /#r-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
        if (!tgrClass || tgrClass == '') {
          targetRegex = wrapRegex;
        } else {
          var targetRegexString = '#r-[^\\s]+' + targetClass + '(\\S*s+)?{(.|\\n)*?\\}';
          targetRegex = new RegExp(targetRegexString, 'g');
        }
        id = '#' + $targetElement.attr('id');
      } else if ($targetElement.hasClass('gf_column')) {
        wrapRegex = targetRegex = /#c-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
        id = '#' + $targetElement.attr('id');
      } else if ($targetElement.hasClass('module-wrap')) {
        wrapRegex = targetRegex = /#m-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
        id = '#' + $targetElement.attr('id');
      } else {
        if ($targetElement.hasClass('element-wrap') || $targetElement.closest('.element-wrap').length > 0) {
          if (tgrClass == '') {
            wrapRegex = targetRegex = /#e-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
            id = '#' + $targetElement.attr('id');
          } else {
            const $elementWrap = $targetElement.closest('.element-wrap');
            if (targetClass == undefined) {
              if ($elementWrap.data('gfelement')) {
                targetClass = $elementWrap.data('gfelement').getTargetClass();
              }
            }
            var targetRegexString = '#e-[^\\s]+\\s+' + targetClass + '(\\S*s+)?{(.|\\n)*?\\}';

            wrapRegex = /#e-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
            targetRegex = new RegExp(targetRegexString, 'g');

            id = '#' + $elementWrap.attr('id');
          }
        } else if ($targetElement.closest('.module-wrap').length > 0) {
          const $moduleWrap = $targetElement.closest('.module-wrap');

          if (targetClass == undefined) {
            if ($moduleWrap.data('gfmodule')) {
              targetClass = $moduleWrap.data('gfmodule').getTargetClass();
            }
          }
          var targetRegexString = '#m-[^\\s]+\\s+' + targetClass + '(\\S*s+)?{(.|\\n)*?\\}';

          wrapRegex = /#m-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
          targetRegex = new RegExp(targetRegexString, 'g');

          id = '#' + $moduleWrap.attr('id');
        } else {
          id = '#' + $targetElement.attr('id');
          wrapRegex = new RegExp(id + '(\\s)*{[^}]*}', 'g');
        }
      }
      // -------
      style = HELPER.formatCSS(style);

      let cssTmp = '';
      if (!style.match(wrapRegex)) {
        cssTmp += '\n' + id + ' {';
        cssTmp += '\n}';
      }
      if (targetRegex != '' && wrapRegex != targetRegex) {
        if (!style.match(targetRegex)) {
          if ($targetElement.hasClass('gf_row')) {
            cssTmp += '\n' + id + targetClass + ' {';
          } else {
            cssTmp += '\n' + id + ' ' + targetClass + ' {';
          }
          cssTmp += '\n}';
        }
      }
      style = cssTmp + style;
      style = HELPER.formatCSS(style);

      if (!style.match(_xsRegex)) {
        var media = '\n/* Mobile */';
        media += '\n@media (max-width: 767px){';
        media += '\n\t' + id + ' {';
        media += '\n\t}';
        media += '\n}';
        style += media;
      }
      if (!style.match(_smRegex)) {
        var media = '\n/* Tablet */';
        media += '\n@media (max-width: 991px) and (min-width: 768px){';
        media += '\n\t' + id + ' {';
        media += '\n\t}';
        media += '\n}';
        style += media;
      }
      if (!style.match(_mdRegex)) {
        var media = '\n/* Laptop */';
        media += '\n@media (max-width: 1199px) and (min-width: 992px){';
        media += '\n\t' + id + ' {';
        media += '\n\t}';
        media += '\n}';
        style += media;
      }
      if (!style.match(_lgRegex)) {
        var media = '\n/* Desktop */';
        media += '\n@media (min-width: 1200px){';
        media += '\n\t' + id + ' {';
        media += '\n\t}';
        media += '\n}';
        style += media;
      }
      style = HELPER.formatCSS(style);

      let oldMediaWindow = '';
      let oldMedia = '';
      switch (screenType) {
        case 'xs':
          oldMedia = style.match(_xsRegex)[0];

          // Fix for windows screen only
          try {
            if (style.match(_xsRegexWindow)) {
              oldMediaWindow = style.match(_xsRegexWindow)[0];
            }
          } catch (error) {}
          break;

        case 'sm':
          oldMedia = style.match(_smRegex)[0];
          break;

        case 'md':
          oldMedia = style.match(_mdRegex)[0];
          break;

        case 'lg':
          oldMedia = style.match(_lgRegex)[0];
          break;
      }

      // Fix for windows screen only
      try {
        if (oldMediaWindow) {
          style = style.replace(oldMediaWindow, '');
        }
      } catch (error) {}

      /**
       * cờ để check xem nếu là margin thì gắn cờ bằng false (k hiểu sao lại làm ngược :D)
       * Nếu flagMargin == false thì sẽ apply tất cả style margin vào wrap chứ k phải target
       */
      let flagMargin = false;

      // Exception for Paginator
      // COLLECTION 2019
      if ($targetElement.closest('.module-wrap').attr('data-label') == 'Paginator') {
        flagMargin = true;
      }

      if (attr?.indexOf('margin') === -1) {
        flagMargin = true;
      }
      switch ($targetElement.attr('class')) {
        case 'gf_product-image-thumb':
          flagMargin = true;
      }

      if ($targetElement.hasClass('gf_row')) {
        flagMargin = true;
      }

      let newMedia = oldMedia;

      if (!newMedia.match(wrapRegex)) {
        var media = '\n\t' + id + ' {';
        media += '\n\t}';
        media += '\n}';
        newMedia = newMedia.slice(0, newMedia.lastIndexOf('}')) + media;
      }

      if (targetRegex != '' && wrapRegex != targetRegex && flagMargin) {
        if (newMedia.match(targetRegex)) {
          var cssOfTarget = newMedia.match(targetRegex)[0];
          newMedia = HELPER.designOptionsForCSS(newMedia, cssOfTarget, attr, value, targetRegex, overWrite);
        } else {
          if (newMedia.match(wrapRegex)) {
            var cssOfWrap = newMedia.match(wrapRegex)[0];

            if ($targetElement.hasClass('gf_row')) {
              var cssOfTarget = '\n\t' + id + '' + targetClass + ' {';
            } else {
              var cssOfTarget = '\n\t' + id + ' ' + targetClass + ' {';
            }

            cssOfTarget += '\n\t}';

            newMedia = newMedia.replace(cssOfWrap, cssOfWrap + cssOfTarget);
            newMedia = HELPER.formatCSS(newMedia);
            newMedia = HELPER.designOptionsForCSS(newMedia, cssOfTarget, attr, value, targetRegex, overWrite);
          }
        }
      } else {
        if (newMedia.match(wrapRegex)) {
          var cssOfWrap = newMedia.match(wrapRegex)[0];
          newMedia = HELPER.designOptionsForCSS(newMedia, cssOfWrap, attr, value, wrapRegex, overWrite);
        }
      }

      style = style.replace(oldMedia, newMedia);

      // Fix for windows screen only
      switch (screenType) {
        case 'xs':
          var newMediaWindow = newMedia;
          newMediaWindow = newMediaWindow.replace('(max-width: 767px)', '(width: 767.2px)');
          style += newMediaWindow;
          break;
      }
    }
    return style;
  },
  getValueFromCSS: function ($targetElement, style, attr, screenType, tgrClass) {
    const _xsRegex = /@media(.*)max-width(.*)767px[^{]+\{([\s\S]+?})\s*}/g;
    const _smRegex = /@media(.*)max-width(.*)991px(.*)and(.*)min-width(.*)768px[^{]+\{([\s\S]+?})\s*}/g;
    const _mdRegex = /@media(.*)max-width(.*)1199px(.*)and(.*)min-width(.*)992px[^{]+\{([\s\S]+?})\s*}/g;
    const _lgRegex = /@media(.*)min-width(.*)1200px[^{]+\{([\s\S]+?})\s*}/g;
    let value = '';
    if ($targetElement != undefined) {
      style = HELPER.formatCSS(style);

      if (style != undefined) {
        let wrapRegex = '';
        let targetRegex = '';
        const idRegex = '';
        let targetClass = tgrClass;
        let id = '';

        if ($targetElement.hasClass('gf_row')) {
          // wrapRegex = targetRegex = /#r-[^\s]+(\S*\s+)?{(.|\n)*?\}/g
          wrapRegex = /#r-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
          if (!tgrClass || tgrClass == '') {
            targetRegex = wrapRegex;
          } else {
            var targetRegexString = '#r-[^\\s]+' + targetClass + '(\\S*s+)?{(.|\\n)*?\\}';
            targetRegex = new RegExp(targetRegexString, 'g');
          }
          id = '#' + $targetElement.attr('id');
        } else if ($targetElement.hasClass('gf_column')) {
          wrapRegex = targetRegex = /#c-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
          id = '#' + $targetElement.attr('id');
        } else if ($targetElement.hasClass('module-wrap')) {
          wrapRegex = targetRegex = /#m-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
          id = '#' + $targetElement.attr('id');
        } else {
          if ($targetElement.hasClass('element-wrap') || $targetElement.closest('.element-wrap').length > 0) {
            const $elementWrap = $targetElement.closest('.element-wrap');

            if (targetClass == undefined) {
              if ($elementWrap.data('gfelement')) {
                targetClass = $elementWrap.data('gfelement').getTargetClass();
              }
            }

            var targetRegexString = '#e-[^\\s]+\\s+' + targetClass + '(\\S*s+)?{(.|\\n)*?\\}';

            wrapRegex = /#e-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
            targetRegex = new RegExp(targetRegexString, 'g');

            id = '#' + $elementWrap.attr('id');
          } else if ($targetElement.closest('.module-wrap').length > 0) {
            const $moduleWrap = $targetElement.closest('.module-wrap');

            if (targetClass == undefined) {
              if ($moduleWrap.data('gfmodule')) {
                targetClass = $moduleWrap.data('gfmodule').getTargetClass();
              }
            }

            var targetRegexString = '#m-[^\\s]+\\s+' + targetClass + '(\\S*s+)?{(.|\\n)*?\\}';
            wrapRegex = /#m-[^\s]+(\S*\s+)?{(.|\n)*?\}/g;
            targetRegex = new RegExp(targetRegexString, 'g');

            id = '#' + $moduleWrap.attr('id');
          }
        }

        const getValueFromString = function (styleString) {
          let val = '';
          let cssMediaObject = '';
          const matchedString = new RegExp('(.?\\s)' + attr + '.*?;', 'g');

          if (targetRegex != '' && wrapRegex != targetRegex && attr.indexOf('margin') === -1) {
            if (styleString.match(targetRegex)) {
              const cssOfTarget = styleString.match(targetRegex)[0];
              cssMediaObject = cssOfTarget;
            } else {
              // ne loai bo phan nay tuy nhien se chi test voi truong hop cua
              // popup close button truo
              if (targetClass != '.gf-closePopup') {
                if (styleString.match(wrapRegex)) {
                  var cssOfWrap = styleString.match(wrapRegex)[0];
                  cssMediaObject = cssOfWrap;
                }
              }
            }
          } else {
            if (styleString.match(wrapRegex)) {
              var cssOfWrap = styleString.match(wrapRegex)[0];
              cssMediaObject = cssOfWrap;
            }
          }
          if (cssMediaObject.match(matchedString)) {
            const line = cssMediaObject.match(matchedString)[0].split(':');
            if (line && line.length > 2) {
              val = line.slice(1).join(':').replace(';', '').replace('!important', '');
            } else {
              val = line[1].replace(';', '').replace('!important', '');
            }
          }
          return jQuery.trim(val);
        };

        switch (screenType) {
          case 'xs':
            var media = style.match(_xsRegex);
            break;
          case 'sm':
            var media = style.match(_smRegex);
            break;
          case 'md':
            var media = style.match(_mdRegex);
            break;
          case 'lg':
            var media = style.match(_lgRegex);
            break;
        }

        if (media) {
          const mediaCSS = media[0];
          value = getValueFromString(mediaCSS);
        } else {
          value = getValueFromString(style);
        }
      }
    }

    //thêm nháy đơn cho font family vì trường hợp Custom Font có khoảng trống (hỗ trợ custom font từ ES)
    if (attr == 'font-family') {
      if (value.charAt(0) == "'" && value.charAt(value.length - 1) == "'") {
        value = value.replace(/^\'|\'$/g, '');
      }
    }
    return value;
  },
  designOptions2Style: function ($targetElement, screenType, style, deOptions, tgrClass, forceOverWrite, moduleName) {
    if ($targetElement != undefined) {
      const arrExcludeDisplay = ['(P) Swatches', '(P) Variants'];
      for (let i = 0; i < deOptions.length; i++) {
        const attr = deOptions[i].key;
        const value = deOptions[i].value;

        if (screenType == 'lg') {
          if (attr != 'display' || arrExcludeDisplay.indexOf(moduleName) !== -1) {
            const devices = ['xs', 'sm', 'md', 'lg'];
            // Kiểm tra xem giá trị có giống nhau trên các màn hình không;
            let found = true;
            let cacheValue = '';
            for (var j = 0; j < devices.length; j++) {
              var screenT = devices[j];
              const v = HELPER.getValueFromCSS($targetElement, style, attr, screenT, tgrClass);
              if (j != 0 && v != cacheValue) {
                found = false;
                break;
              }
              cacheValue = v;
            }

            // Nếu các giá trị giống nhau trên các màn hình thì ghi đè
            if (found) {
              for (var j = 0; j < devices.length; j++) {
                var screenT = devices[j];
                if (screenT != screenType) {
                  const screenValue = value;
                  // if (attr == 'margin-left' ||
                  //   attr == 'margin-right' ||
                  //   attr == 'padding-left' ||
                  //   attr == 'padding-right') {

                  //   switch (screenT) {
                  //     case 'sm':
                  //       var screenValue = (parseFloat(value) / 5);

                  //       if (value.indexOf('px') != -1) {
                  //         screenValue += 'px';
                  //       } else if (value.indexOf('%') != -1) {
                  //         screenValue += '%';
                  //       }
                  //       break;

                  //     case 'xs':
                  //       screenValue = (parseFloat(value) / 10);

                  //       if (value.indexOf('px') != -1) {
                  //         screenValue += 'px';
                  //       } else if (value.indexOf('%') != -1) {
                  //         screenValue += '%';
                  //       }
                  //       break;
                  //   }
                  // }
                  const $designOptions = $('#md-settings').find('.design-options');
                  const valPosition = $designOptions.find('#position').val();
                  if (checkKeyValid('stickyAllScreenMode') && valPosition == 'fixed') {
                    if (!(attr == 'top' || attr == 'bottom' || attr == 'left' || attr == 'right')) {
                      style = HELPER.setValueFromCSS($targetElement, style, attr, screenValue, screenT, tgrClass, true);
                    }
                  } else {
                    style = HELPER.setValueFromCSS($targetElement, style, attr, screenValue, screenT, tgrClass, true);
                  }
                }
              }
            }
          }
        }
        // overwrite current screen
        style = HELPER.setValueFromCSS($targetElement, style, attr, value, screenType, tgrClass, true);
      }
    }
    return style;
  },
  checkVisible: function ($element, callback) {
    if (
      $element.css('visibility') == 'hidden' ||
      $element.height() == 0 ||
      $element.css('display') == 'none' ||
      $element.css('opacity') == '0'
    ) {
      callback(true);
    } else {
      callback(false);
    }
  },
  json2css: function (id, json) {
    let style = '#' + id + ' {\n';
    for (const key in json) {
      style += '\t' + key + ': ' + json[key] + '\n';
    }
    style += '}\n';
    return style;
  },
  rgb2hex: function (rgb) {
    let result = rgb;
    if (rgb != undefined) {
      if (rgb.indexOf('rgb(') != -1) {
        var tmp = rgb.replace('rgb(', '').replace(')', '');
        if (tmp) {
          var arr = tmp.split(',');
          if (arr.length == 3) {
            const componentToHex = function (c) {
              const hex = parseInt(c).toString(16);
              return hex.length == 1 ? '0' + hex : hex;
            };
            result = '#' + componentToHex(arr[0]) + componentToHex(arr[1]) + componentToHex(arr[2]);
          }
        }
      } else if (rgb.indexOf('rgba(') != -1) {
        var tmp = rgb.replace('rgba(', '').replace(')', '');
        if (tmp) {
          var arr = tmp.split(',');
          if (arr.length == 4 && arr[3].trim() == '0') {
            result = 'transparent';
          }
        }
      }
    }
    return result;
  },
  rgbToFullHex({ r, g, b, a }) {
    const change = (val) => ('0' + Number(val).toString(16)).slice(-2);
    let alpha = Math.round(a * 255);
    alpha = change(alpha);
    alpha = alpha === 'ff' ? '' : alpha;
    return `#${change(r)}${change(g)}${change(b)}${alpha}`;
  },
  hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    };
  },
  hex2rgba(hex) {
    const change = (val) => parseInt(val, 16) || 0;
    const convertHexToAlpha = (val) => ((parseInt(val, 16) || 0) / 255).toFixed(2);
    if (hex.toLowerCase().startsWith('0x')) hex = hex.slice(2);
    else hex = hex.slice(1);
    if (hex.length < 4) {
      return {
        r: change(hex.slice(0, 1).repeat(2)),
        g: change(hex.slice(1, 2).repeat(2)),
        b: change(hex.slice(2, 3).repeat(2)),
        a: 1,
      };
    }
    return {
      r: change(hex.slice(0, 2)),
      g: change(hex.slice(2, 4)),
      b: change(hex.slice(4, 6)),
      a: hex.length > 6 ? convertHexToAlpha(hex.slice(6, 8)) : 1,
    };
  },
  rgbaOrighex(orig) {
    let a,
      isPercent,
      rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
      alpha = ((rgb && rgb[4]) || '').trim(),
      hex = rgb
        ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
          (rgb[2] | (1 << 8)).toString(16).slice(1) +
          (rgb[3] | (1 << 8)).toString(16).slice(1)
        : orig;

    if (alpha !== '') {
      a = alpha;
    } else {
      a = 0o1;
    }
    // multiply before convert to HEX
    a = ((a * 255) | (1 << 8)).toString(16).slice(1);
    hex = hex + a;

    return `#${hex}`;
  },
  randomIntFromInterval: function (min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  },
  // MER = Module - Element - Row
  initMERfromSnippet: function (
    $snippet,
    $elm,
    callback,
    notOpenSettings,
    notInitChildren,
    preloadSnippetProduct = false,
  ) {
    if (!$snippet) {
      return false;
    }
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $gryffEditor = $gryffBody.find('.gryffeditor').first();

    // Collection page
    if ($elm == undefined) {
      if ($gryffEditor.children('.block-placeholder').length > 0) {
        $elm = $gryffEditor.children('.block-placeholder').first();
      } else {
        $elm = jQuery('<div class="block-placeholder"></div>');
        $elm.prependTo($gryffEditor);
      }
    }

    const type = $snippet.attr('data-type');
    const label = $snippet.attr('data-label') ? $snippet.attr('data-label') : 'Unknown';
    const key = $snippet.attr('data-key') ? $snippet.attr('data-key') : '-';
    const icon = $snippet.attr('data-icon') ? $snippet.attr('data-icon') : 'images/icons/default.png';
    const isForm = $snippet.attr('data-form') ? $snippet.attr('data-form') : '';
    var $toModule = $elm.closest('.module-wrap');

    if (type == 'module') {
      if (
        (label == 'PickyStory' || label == 'Product List' || label == 'Article List' || label == 'Related Products') &&
        (HELPER.isInsideTheList($elm) || $elm.closest('[data-label="Product"]').length > 0)
      ) {
        if (HELPER.isInsideTheList($elm)) {
          HELPER.showNotify('Cannot put a list inside another list.', 'error');
        } else {
          HELPER.showNotify('Cannot put a ' + label + ' inside a Product.', 'error', 2000);
        }
      } else if (label === 'Product' && $toModule.length && $toModule.closest('[data-label="Product"]').length > 0) {
        HELPER.showNotify('Product Module cannot contain another Product.', 'error');
      } else if (
        label === 'Product' &&
        $gryffEditor
          .find('[data-label="Product"]')
          .not('[id*="-child"]')
          .not('[data-status="default"],[data-status="dynamic"]').length >= 20
      ) {
        HELPER.showNotify('Product module quantity can not exceed 20.', 'error');
      } else if (label === 'Article' && $toModule.closest('[data-label="Article"]').length > 0) {
        HELPER.showNotify('Article Module cannot contain another Article.', 'error');
      } else if (
        (label === 'Product Filter Search' ||
          label === 'PickyStory' ||
          label === 'WideBundle' ||
          label === 'Collection Toolbar' ||
          label === 'Paginator' ||
          label === 'Collection Banner' ||
          label == 'Collection Title' ||
          label == 'Collection Desc') &&
        HELPER.isInsideTheList($elm)
      ) {
        HELPER.showNotify('Cannot put a ' + label + ' inside a Product List.', 'error', 3000);
      } else if (
        (label === 'Collection Toolbar' ||
          label === 'Paginator' ||
          label === 'Collection Banner' ||
          label == 'Collection Title' ||
          label == 'Collection Desc') &&
        $gfFrame.data('gfframe').getPageType() != 'template-collection'
      ) {
        HELPER.showNotify(label + ' can only be used inside a Collection Page.', 'error');
      } else {
        const pageCollectionArr = ['Product Filter Search', 'Smart Search & Instant Search'];
        const pArr = [
          '(P) Title',
          '(P) File Upload',
          '(P) Vendor',
          '(P) SKU',
          'Ultimate Sales Boost',
          'WideBundle',
          '(P) Price',
          '(P) Quantity',
          '(P) Image',
          '(P) Image List',
          '(P) Ali Reviews',
          '(P) Stock Counter',
          '(P) Cart Button',
          '(P) Dynamic Checkout Button',
          '(P) View More',
          '(P) Description',
          '(P) Variants',
          '(P) Swatches',
          '(P) Meta',
          'Infinite Options',
          'Recharge Subscription',
          'Bold Subscriptions',
          'Bold Product Options',
          'Seal Subscriptions',
        ];
        const aArr = ['(A) Title', '(A) Content', '(A) Excerpt', '(A) Image', '(A) Date'];
        const reviewsArr = [
          'Ultimate Sales Boost',
          'WideBundle',
          'Product Personalizer',
          'Loox Product Page + Stars',
          'Judge.me Reviews',
          'Product Reviews',
          'Trustoo',
          'Growave',
          'Yotpo - Product & Collection Page',
          'Ryviu: Product Review App',
          'Stamped.io - Product & Collection Page',
          'Rivyo Reviews',
          'Opinew - Product & Collection Pages',
          'Appstle Subscriptions',
          'Kaching Bundle Quantity Breaks',
        ];
        const pageProductArr = [
          'Frequently Bought Together',
          'Cross Sell',
          'Wiser - Product & Collection Page',
          'Tobi - Opt-in Checkbox',
          'Infinite Options',
        ];
        if (
          jQuery.inArray(label, pArr) !== -1 &&
          ($toModule.length === 0 || $toModule.closest('[data-label="Product"]').length === 0)
        ) {
          HELPER.showNotify('This field is dropped to Product Module only.', 'error');
        } else if (
          jQuery.inArray(label, aArr) !== -1 &&
          ($toModule.length === 0 || $toModule.closest('[data-label="Article"]').length === 0)
        ) {
          HELPER.showNotify('This field is dropped to Article Module only.', 'error');
        } else if (
          jQuery.inArray(label, reviewsArr) !== -1 &&
          $gfFrame.data('gfframe').getPageType() != 'template-product' &&
          ($toModule.length === 0 || $toModule.closest('[data-label="Product"]').length === 0)
        ) {
          HELPER.showNotify('This module is not linked to any product.', 'error');
        } else if (
          jQuery.inArray(label, pageCollectionArr) !== -1 &&
          $gfFrame.data('gfframe').getPageType() != 'template-collection'
        ) {
          HELPER.showNotify('This field is dropped to Collection Page only', 'error');
        } else if (
          jQuery.inArray(label, pageProductArr) !== -1 &&
          $gfFrame.data('gfframe').getPageType() != 'template-product'
        ) {
          HELPER.showNotify('This field is dropped to Product Page only', 'error');
        } else if (
          label == 'Ultimate Sales Boost' &&
          HELPER.isInsideTheList($elm) &&
          $elm.closest('[data-label="Product List"]').length > 0 &&
          $gfFrame.data('gfframe').getPageType() === 'template-product'
        ) {
          HELPER.showNotify('Cannot put a ' + label + ' into a Product List of Product Page', 'error', 5000);
        } else {
          //block FORM to FORM
          let isFormToForm = false;
          if (listForms.indexOf(label) != -1) {
            for (let i = 0; i < listForms.length; i++) {
              if ($elm.closest('[data-label="' + listForms[i] + '"]').length) {
                HELPER.showNotify('Cannot put a ' + label + ' inside a ' + listForms[i] + '.', 'error');
                isFormToForm = true;
                break;
              }
            }
          }
          if (!isFormToForm) {
            const $activeModule = jQuery('<div/>');
            $activeModule.attr('data-label', label);
            if (preloadSnippetProduct) {
              $activeModule.attr('data-preload', preloadSnippetProduct);
            }
            $activeModule.attr('data-key', key);

            const group = addModuleGroupJquery($activeModule);
            $activeModule.attr('data-atomgroup', group);

            switch (label) {
              case 'Popup':
                $activeModule.appendTo($gryffBody);
                break;

              case 'Related Products':
                if ($toModule.length && $toModule.closest('[data-label="Product"]').length > 0) {
                  $activeModule.insertAfter($toModule);
                  break;
                }

              default:
                $activeModule.insertAfter($elm);
                break;
            }

            // $activeModule.gfModule({
            //     snippet: $snippet,
            //     notInitChildren: notInitChildren
            // });
            atom.Init($activeModule, {
              snippet: $snippet,
              notInitChildren: notInitChildren,
            });
            // Show popup at the first time
            if (label == 'Popup') {
              setTimeout(function () {
                if ($activeModule.data('gfmodule') != undefined) {
                  const moduleId = $activeModule.data('gfmodule').getModuleId();
                  const moduleIdSlug = moduleId.toString().replace(/-/g, '');

                  const func = 'getPopup' + moduleIdSlug;
                  if (document.getElementById('gfFrame').contentWindow[func]) {
                    document.getElementById('gfFrame').contentWindow[func]().show();
                  }
                }
              }, 52);
            }

            // open settings panel
            // In collection page, since we preload 3 modules, don't open module setting
            if (notOpenSettings == undefined || notOpenSettings == false) {
              setTimeout(function () {
                $activeModule.data('gfmodule').openModuleSettings();
              }, 50);
            }

            // detect element or module change
            HELPER.flagListItemChange($activeModule, 'new');

            var $itemContent = $elm.closest('.item-content');
            HELPER.detectContentChange($itemContent);

            if (callback) {
              callback($activeModule);
            }

            setTimeout(function () {
              const $currentTargetElement = $activeModule;
              let position = {};
              const $gfFrame = jQuery('#gfFrame');
              const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();

              if ($gryffEditor.data('gfhistory')) {
                position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
              }
              const history = {
                id: $currentTargetElement.attr('id'),
                action: 'add',
                position: position,
              };
              $gryffEditor.trigger('history', history);
            }, 300);
          }
        }
      }
    } else if (type == 'element') {
      const $activeElement = jQuery('<div>');
      $activeElement.attr('data-label', label);
      $activeElement.attr('data-key', key);
      $activeElement.attr('data-atomgroup', AtomGroup.Element);

      if (isForm != '') {
        $activeElement.attr('data-form', isForm);
      }

      $activeElement.insertAfter($elm);
      // $activeElement.gfElement({
      //     snippet: $snippet
      // });
      atom.Init($activeElement, {
        snippet: $snippet,
      });

      var $toModule = $activeElement.closest('.module-wrap');

      const activeElementLabel = $activeElement.attr('data-label');
      if (
        activeElementLabel &&
        ['Email Field', 'Text Field', 'Text Area', 'Dropdown', 'Checkbox'].includes(activeElementLabel)
      ) {
        if ($toModule) {
          const toModuleLabel = $toModule.attr('data-label');
          if (toModuleLabel) {
            const elementInputField = $activeElement.find('.elm input');
            const elementTextAreaField = $activeElement.find('.elm textarea');
            const elementSelectField = $activeElement.find('.elm select');

            if (toModuleLabel == 'Product') {
              if (elementInputField.length) {
                var fieldName = elementInputField.attr('name');
                if (fieldName.includes('contact[')) {
                  elementInputField.attr('name', fieldName.replace('contact[', 'properties['));
                } else if (!fieldName.includes('[')) {
                  elementInputField.attr('name', 'properties[' + fieldName + ']');
                }
              }
              if (elementTextAreaField.length) {
                var fieldName = elementTextAreaField.attr('name');
                if (fieldName.includes('contact[')) {
                  elementTextAreaField.attr('name', fieldName.replace('contact[', 'properties['));
                } else if (!fieldName.includes('[')) {
                  elementTextAreaField.attr('name', 'properties[' + fieldName + ']');
                }
              }
              if (elementSelectField.length) {
                var fieldName = elementSelectField.attr('name');
                if (fieldName.includes('contact[')) {
                  elementSelectField.attr('name', fieldName.replace('contact[', 'properties['));
                } else if (!fieldName.includes('[')) {
                  elementSelectField.attr('name', 'properties[' + fieldName + ']');
                }
              }
            } else if (toModuleLabel == 'Contact Form') {
              if (elementInputField.length) {
                var fieldName = elementInputField.attr('name');
                if (fieldName.includes('properties[')) {
                  elementInputField.attr('name', fieldName.replace('properties[', 'contact['));
                } else if (!fieldName.includes('[')) {
                  elementInputField.attr('name', 'contact[' + fieldName + ']');
                }
              }
              if (elementTextAreaField.length) {
                var fieldName = elementTextAreaField.attr('name');
                if (fieldName.includes('properties[')) {
                  elementTextAreaField.attr('name', fieldName.replace('properties[', 'contact['));
                } else if (!fieldName.includes('[')) {
                  elementTextAreaField.attr('name', 'contact[' + fieldName + ']');
                }
              }
              if (elementSelectField.length) {
                var fieldName = elementSelectField.attr('name');
                if (fieldName.includes('properties[')) {
                  elementSelectField.attr('name', fieldName.replace('properties[', 'contact['));
                } else if (!fieldName.includes('[')) {
                  elementSelectField.attr('name', 'contact[' + fieldName + ']');
                }
              }
            } else if (toModuleLabel == 'Newsletter') {
              if (elementInputField.length) {
                var fieldName = elementInputField.attr('name');
                if (fieldName.includes('properties[')) {
                  elementInputField.attr('name', fieldName.replace('properties[', 'customer['));
                } else if (!fieldName.includes('[')) {
                  elementInputField.attr('name', 'customer[' + fieldName + ']');
                }
              }
              if (elementTextAreaField.length) {
                var fieldName = elementTextAreaField.attr('name');
                if (fieldName.includes('properties[')) {
                  elementTextAreaField.attr('name', fieldName.replace('properties[', 'customer['));
                } else if (!fieldName.includes('[')) {
                  elementTextAreaField.attr('name', 'customer[' + fieldName + ']');
                }
              }
              if (elementSelectField.length) {
                var fieldName = elementSelectField.attr('name');
                if (fieldName.includes('properties[')) {
                  elementSelectField.attr('name', fieldName.replace('properties[', 'customer['));
                } else if (!fieldName.includes('[')) {
                  elementSelectField.attr('name', 'customer[' + fieldName + ']');
                }
              }
            }
          }
        }
      }

      // open settings panel
      if (notOpenSettings == undefined || notOpenSettings == false) {
        setTimeout(function () {
          $activeElement.data('gfelement').openElementSettings();
        }, 50);
      }

      // detect element or module change
      HELPER.flagListItemChange($activeElement, 'new');

      var $itemContent = $elm.closest('.item-content');
      HELPER.detectContentChange($itemContent);

      if (callback) {
        callback($activeElement);
      }

      setTimeout(function () {
        const $currentTargetElement = $activeElement;
        let position = {};
        const $gfFrame = jQuery('#gfFrame');
        const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }
        const history = {
          id: $currentTargetElement.attr('id'),
          action: 'add',
          position: position,
        };
        $gryffEditor.trigger('history', history);
      }, 300);
    } else if (type == 'row') {
      const $activeRow = jQuery('<div>');
      $activeRow.attr('data-label', label);
      $activeRow.attr('data-key', key);
      $activeRow.attr('data-atomgroup', AtomGroup.Row);

      $activeRow.insertAfter($elm);
      // $activeRow.gfRow({
      //     snippet: $snippet
      // });
      atom.Init($activeRow, {
        snippet: $snippet,
      });

      // open settings panel
      if (notOpenSettings == undefined || notOpenSettings == false) {
        setTimeout(function () {
          $activeRow.data('gfrow').openRowSettings();
        }, 50);
      }

      // detect element or module change
      HELPER.flagListItemChange($activeRow, 'new');

      var $itemContent = $elm.closest('.item-content');
      HELPER.detectContentChange($itemContent);

      if (callback) {
        callback($activeRow);
      }

      setTimeout(function () {
        const $currentTargetElement = $activeRow;
        let position = {};
        const $gfFrame = jQuery('#gfFrame');
        const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }
        const history = {
          id: $currentTargetElement.attr('id'),
          action: 'add',
          position: position,
        };
        $gryffEditor.trigger('history', history);
      }, 300);
    }

    HELPER.refreshFrame();

    return true;
  },
  /**
   * Add snippet to editor
   * @param {array} snippets array contains all snippets information we want to add
   * @param {number} position position in snippets we want to add
   * @param {object} $holder where we want to place new snippet into
   */
  addSnippetToEditor: function (snippets, position, $holder) {
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();

    if (position < 0) {
      return false;
    }

    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $snippets = $gfLeftSideBar.find('.side-panels').find('#md-snippets .snippet');

    const label = snippets[position].label;
    const settings = snippets[position].settings || {};
    const items = snippets[position].items || [];
    const placeholder = snippets[position].placeholder || 0;
    const preloadSnippetProduct = snippets[position].preloadSnippetProduct || false;
    if ($holder != undefined) {
      const $parentMR = $holder.closest('.module-wrap, .gf_row');

      switch ($parentMR.attr('data-label')) {
        case 'Row':
          var $movedPlaceholder = $parentMR.children('.gf_column').eq(placeholder).find('.block-placeholder').first();
          if ($movedPlaceholder.length > 0) {
            $holder = $movedPlaceholder;
          }
          break;
        case 'Tab':
        case 'Accordion':
        case 'Carousel':
          // Dear developer,
          //
          // In case you want to implement placeholder for other modules from Row, you should do it right here
          // You should find the correct .block-placeholder in the right place of the modules
          // For more information, refer to the 'Snippet JSON API' in gryffEditor.js
          break;
        default:
          break;
      }
    }

    if ($snippets.filter('[data-label="' + label + '"]').length > 0) {
      let $snippet = $snippets
        .filter('[data-label="' + label + '"]')
        .first()
        .clone();

      const storeSnippet = app.$store.getters['editor/GET_SNIPPETS_BY_KEY']($snippet.attr('data-key'));
      $snippet = jQuery(storeSnippet);

      if ($snippet.find('.settings').length > 0) {
        try {
          const snippetSettings = JSON.parse($snippet.find('.settings').html());

          var replaceSettings = function (settingsArray, i) {
            if (i >= settingsArray.length) {
              return;
            }

            if (settingsArray[i]['type'] != 'group' && settingsArray[i]['name'] != undefined) {
              const setting = settingsArray[i]['name'];
              if (settings[setting] != undefined) {
                settingsArray[i]['default_value'] = settings[setting];
              }
            }

            if (settingsArray[i]['type'] == 'group' && settingsArray[i]['items'] != undefined) {
              replaceSettings(settingsArray[i]['items'], 0);
            }

            replaceSettings(settingsArray, i + 1);
          };

          replaceSettings(snippetSettings, 0);
          $snippet.find('.settings').html(JSON.stringify(snippetSettings));
        } catch (e) {
          // Silence is golden
        }
      }

      if ($snippet.find('.libs').length > 0 && $snippet.find('.libs').html().trim() != '') {
        try {
          const libJson = jQuery.parseJSON($snippet.find('.libs').html());
          const libs = [];
          for (let j = 0; j < libJson['libs'].length; j++) {
            if (jQuery.inArray(libJson['libs'][j], window._pageLibs) === -1) {
              libs.push(libJson['libs'][j]);
            }
          }

          HELPER.getLibs({
            urls: libs,
            start: function () {},
            done: function () {
              for (let j = 0; j < libs.length; j++) {
                if (jQuery.inArray(libs[j], window._pageLibs) === -1) {
                  window._pageLibs.push(libs[j]);
                }
              }
              setTimeout(function () {
                HELPER.initMERfromSnippet(
                  $snippet,
                  $holder,
                  function ($module) {
                    if (label == 'Product' && settings['dynamic'] == '1') {
                      const dataModule = $module.data('gfmodule');
                      dataModule.setDynamic(true);
                      dataModule.reConvertAssignVersion();
                      dataModule.refresh();
                    } else if (label == 'Collection Banner') {
                      const _title = $gfFrame.data('gfframe').getPageTitle();
                      const _handle = $gfFrame.data('gfframe').getPageHandle();
                      const _meta = $gfFrame.data('gfframe').getPageMeta();
                      const dataPage = {
                        title: _title,
                        handle: _handle,
                        meta: _meta,
                      };
                      if ($gryffEditor.data('gryffeditor') != undefined) {
                        // Disable this line because it always publish Collection Page whenever go to editor
                        // $gryffEditor.data('gryffeditor').savePage('publish', undefined, dataPage, undefined, false);
                      }
                    }
                    if (items != undefined) {
                      const $placeHolder = $module.find('.block-placeholder').first();
                      if ($placeHolder.length != 0) {
                        HELPER.addSnippetToEditor(items, items.length - 1, $placeHolder);
                      }
                    }
                    HELPER.addSnippetToEditor(snippets, position - 1, $holder);
                  },
                  true,
                  items.length > 0,
                  preloadSnippetProduct,
                );
              }, 300);
            },
            error: function () {
              HELPER.showNotify('There are some errors occurred please try again.', 'error');
              $loading.remove();
            },
            block: function () {
              /**
               * trường hợp bị cookieyes chặn
               * Vẫn done như bình thường và gắn cờ bị block js
               */
              for (let i = 0; i < libs.length; i++) {
                if (jQuery.inArray(libs[i], window._pageLibsBlocked) === -1) {
                  window._pageLibsBlocked.push(libs[i]);
                }
              }
              this.done();
            },
          });
        } catch (err) {
          console.log(err.message);
        }
      } else {
        HELPER.initMERfromSnippet(
          $snippet,
          $holder,
          function ($module) {
            if (label == 'Product List' && settings['dynamic'] == '1') {
              $module.data('gfmodule').setDynamic(true);
            } else if (label == 'Row') {
              // Since Row do not have settings section, we must set them manually
              if (settings['row-type'] == '1') {
                $module.addClass('gf_row-fluid gf_row-no-padding');
              } else {
                $module.removeClass('gf_row-fluid gf_row-no-padding');
              }

              if (settings['gf_row-layout'] && $module.data('gfrow')) {
                $module.data('gfrow').setRowLayout(settings['gf_row-layout']);

                const responsiveSize = ['md', 'sm', 'xs'];
                responsiveSize.forEach(function (screenSize) {
                  const layout = settings['gf_row-layout-' + screenSize];
                  if (layout) {
                    const colSizes = layout.split('+');
                    let classRemoved = '';
                    for (let i = 1; i <= 12; i++) {
                      classRemoved += `gf_col-${screenSize}-${i} `;
                    }

                    $module.children('.gf_column').each(function (index, column) {
                      const $col = jQuery(column);
                      $col.removeClass(classRemoved);
                      const classAdded = colSizes.length > index ? `gf_col-${screenSize}-${colSizes[index]}` : '';
                      $col.addClass(classAdded);
                    });
                  }
                });
              }
            }
            if (items != undefined) {
              const $placeHolder = $module.find('.block-placeholder').first();
              if ($placeHolder.length != 0) {
                HELPER.addSnippetToEditor(items, items.length - 1, $placeHolder);
              }
            }
            HELPER.addSnippetToEditor(snippets, position - 1, $holder);
          },
          true,
          items.length > 0,
          preloadSnippetProduct,
        );
      }
    }
  },
  isPageEmpty: function () {
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    return $gryffEditor.children('div:not(.preload-insert-data)').length === 1;
  },
  clearPageContent: function () {
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $divContentBk = $gfFrame.contents().find('#divContentBk');
    $gryffEditor.children('div:not(#divNewBlock)').remove();
    $divContentBk.empty();
    return false;
  },

  setContentBkToStore: () => {
    const $gfFrame = jQuery('#gfFrame');
    const $divContentBk = $gfFrame.contents().find('#divContentBk');
    // map data divContentBk to store when render
    // support for data contentBk old
    if ($divContentBk.length !== 0 && $divContentBk.html().length !== 0) {
      HELPER.mapDataToStore($divContentBk);
      $divContentBk.remove();
    } else {
      app.$store.state['editor'].isBlankPage = true;
    }
    return false;
  },

  addContentToStore: (html) => {
    const $bkHtml = jQuery('<div />').html(html);
    HELPER.mapDataToStore($bkHtml);
    return false;
  },

  mapDataToStore: ($this) => {
    const $gfFrame = jQuery('#gfFrame');
    const $elementStyleContainer = $gfFrame.contents().find('#' + elementTypes._elementStyleContainer);
    const $moduleStyleContainer = $gfFrame.contents().find('#' + moduleTypes._moduleStyleContainer);
    const $rowStyleContainer = $gfFrame.contents().find('#' + rowTypes._rowStyleContainer);
    const $columnStyleContainer = $gfFrame.contents().find('#' + rowTypes._columnStyleContainer);
    const $interactions = $gfFrame.contents().find('#interactions');
    const $actions = $gfFrame.contents().find('#actions');

    const isBlankPage = app.$store.state['editor'].isBlankPage;
    if (isBlankPage) {
      app.$store.state['editor'].isBlankPage = false;
      emitter.emit('page:blank', false);
    }

    $this.children().each(function () {
      const attrId = jQuery(this).attr('id');
      if (!attrId || typeof attrId !== 'string') {
        Sentry.withScope((scope) => {
          scope.setLevel('warning');
          scope.setExtra(
            'data',
            JSON.stringify({
              attrId: attrId,
              description:
                'It happened when the structured `Liquid` module failed (May be lead to the issue lost content)',
            }),
          );
          Sentry.captureMessage(`EDITOR MISSING ID ATTRIBUTE- ${window.___gemShopInfo?.shopifyDomain}`);
        });
        return;
      }
      const domType = attrId.split('-').first();
      const domId = attrId.replace(`${domType}-`, '');

      const $style = jQuery(this).find('.style');
      const $bkStyle = jQuery(this).find('.bkstyle');
      const $template = jQuery(this).find('.template');
      const $settings = jQuery(this).find('.settings');
      const $libs = jQuery(this).find('.libs');
      const $data = jQuery(this).find('.data');
      const $script = jQuery(this).find('.script');
      const $dataAtomSetting = jQuery(this).find('.data-atom-settings');
      const $templateChildHtml = jQuery(this).find('.template-child-html');
      const $templateChildBkHtml = jQuery(this).find('.template-child-bkhtml');

      const interaction = jQuery(this).find('.interaction');
      const actions = jQuery(this).find('.actions');

      /* Save Style to Store */
      const _style = $style.html();
      if ($style.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._style + '-' + attrId,
          value: _style,
        });
      }

      /* Save BkStyle to Store */
      const _bkStyle = $bkStyle.first().html();
      if ($bkStyle.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._bkStyle + '-' + attrId,
          value: _bkStyle,
        });
      }

      /* Save Template to Store */
      if ($template.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._template + '-' + attrId,
          value: $template.html(),
        });
      }

      /* save Data to Store */
      if ($data.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._data + '-' + attrId,
          value: $data.html(),
        });
      }

      /* save Settings to Store */
      if ($settings.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._settings + '-' + attrId,
          value: $settings.html(),
        });
      }

      /* save Libs to Store */
      if ($libs.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._libs + '-' + attrId,
          value: $libs.html(),
        });
      }

      /* save Script to Store */
      if ($script.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._script + '-' + attrId,
          value: $script.html(),
        });
      }

      /* save Script to Store */
      if ($dataAtomSetting.length > 0) {
        const html = $dataAtomSetting.html();
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: domId,
          value: html,
        });
        if (html) {
          const jsonData = JSON.parse(html);
          setTimeout(() => {
            addElement(jsonData.merId, jsonData.key);
          }, 0);
        }
      }

      /* save Template Child Html to Store */
      if ($templateChildHtml.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._templateChildHtml + '-' + attrId,
          value: $templateChildHtml.html(),
        });
      }

      /* save Template Child BkHtml to Store */
      if ($templateChildBkHtml.length > 0) {
        app.$store.commit('editor/SET_DATA_SETTINGS', {
          id: base._templateChildBkHtml + '-' + attrId,
          value: $templateChildBkHtml.html(),
        });
      }

      $style.remove();
      $bkStyle.remove();
      $template.remove();
      $settings.remove();
      $libs.remove();
      $data.remove();
      $script.remove();
      $dataAtomSetting.remove();
      $templateChildHtml.remove();
      $templateChildBkHtml.remove();

      interaction.remove();
      actions.remove();

      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: base._snippet + '-' + attrId,
        value: jQuery(this).html(),
        isInit: true,
      });

      if (interaction.text()) {
        app.$store.commit('editor/SET_ANIMATION_DATA_SETTINGS', {
          id: base._interactions + '_' + attrId,
          type: 'interaction',
          value: interaction.text(),
        });
      }

      if (actions.text()) {
        app.$store.commit('editor/SET_ANIMATION_DATA_SETTINGS', {
          id: base._actions + '_' + attrId,
          type: 'action',
          value: actions.text(),
        });
      }

      /* Start handle style */
      const styleTemplate = jQuery(`<div id="${base._style}-${domId}"><style class="style">${_style}</style></div>`);
      /* Load style khi vào view editor & Save Style to Store */

      switch (domType) {
        case 'element':
          if (_style) {
            $elementStyleContainer.find(`#${base._style}-${domId}`).remove();
            styleTemplate.appendTo($elementStyleContainer);
          }
          break;
        case 'module':
          if (_style) {
            $moduleStyleContainer.find(`#${base._style}-${domId}`).remove();
            styleTemplate.appendTo($moduleStyleContainer);
          }
          break;
        case 'row':
          if (_style) {
            $rowStyleContainer.find(`#${base._style}-${domId}`).remove();
            styleTemplate.appendTo($rowStyleContainer);
          }
          break;
        case 'column':
          if (_style) {
            $columnStyleContainer.find(`#${base._style}-${domId}`).remove();
            styleTemplate.appendTo($columnStyleContainer);
          }
          break;
      }

      /* End handle style */
    });
    return false;
  },

  addContentToDom: (html) => {
    const $gfFrame = jQuery('#gfFrame');
    const $divContentBk = $gfFrame.contents().find('#divContentBk');
    const $bkHtml = jQuery('<div />').html(html);
    $bkHtml.children().each(function () {
      const id = '#' + jQuery(this).attr('id');
      if ($divContentBk.find(id).length > 0) {
        $divContentBk.find(id).remove();
      }
    });
    $divContentBk.append(html);
    return false;
  },

  addContentBk: function (html) {
    return this.addContentToStore(html);
  },

  clearContentBk: function () {
    const $gfFrame = jQuery('#gfFrame');
    const $divContentBk = $gfFrame.contents().find('#divContentBk');
    const $gryffBody = $gfFrame.contents().find('body').first();
    $divContentBk.children('div').each(function () {
      const $bkContent = jQuery(this);
      const bkId = $bkContent.attr('id');
      if (bkId != undefined) {
        let id = '';
        if (bkId.indexOf('element-') !== -1) {
          id = bkId.split('element-')[1];
        } else if (bkId.indexOf('module-') !== -1) {
          id = bkId.split('module-')[1];
        } else if (bkId.indexOf('column-') !== -1) {
          id = bkId.split('column-')[1];
        } else if (bkId.indexOf('row-') !== -1) {
          id = bkId.split('row-')[1];
        }
        if (id != '' && $gryffBody.find('[data-id="' + id + '"]').length == 0) {
          $bkContent.remove();
        }
      }
    });
  },
  detectContentChange: function ($itemContent) {
    // detect module / element changes

    if (window._contentChangeTimeout) {
      clearTimeout(window._detechContentChangeTimeout);
      window._contentChangeTimeout = null;
    }
    window._detechContentChangeTimeout = setTimeout(function () {
      if (!$itemContent.hasClass('item-content')) {
        $itemContent = $itemContent.closest('.item-content');
      }

      if ($itemContent != undefined) {
        if ($itemContent.attr('data-index') != undefined) {
          var index = parseInt($itemContent.attr('data-index')) - 1;
        } else {
          var index = 0;
        }
        if ($itemContent.attr('data-key') != undefined) {
          var key = $itemContent.attr('data-key');
        } else {
          var key = 'content';
        }
        let content = $itemContent.html();
        content = HELPER.clearExportedData(content);

        // clear content if dynamic field
        // remove long dynamic content
        const $html = jQuery('<div />').html(content);
        $html.find('[data-label="(P) Description"] .module').empty();
        $html.find('[data-label="(A) Content"] .module').empty();
        // clear list item
        $html.find('[data-child-updated="delete"]').remove();
        $html.find('[data-child-updated]').removeAttr('data-child-updated');

        content = $html.html();

        content = content.replace(/script>/g, 'scri-pt>');

        const $activeModule = $itemContent.closest('.module-wrap');
        if ($activeModule.data('gfmodule') != undefined) {
          $activeModule.data('gfmodule').detectModuleChange(index, key, content);
        }
      }
    }, 300);

    return false;
  },
  newDetectContentChange: async function ($itemContent) {
    return new Promise((resolve) => {
      // detect module / element changes
      if (window._contentChangeTimeout) {
        clearTimeout(window._detechContentChangeTimeout);
        window._contentChangeTimeout = null;
      }
      window._detechContentChangeTimeout = setTimeout(function () {
        if (!$itemContent.hasClass('item-content')) {
          $itemContent = $itemContent.closest('.item-content');
        }

        if ($itemContent != undefined) {
          if ($itemContent.attr('data-index') != undefined) {
            var index = parseInt($itemContent.attr('data-index')) - 1;
          } else {
            var index = 0;
          }
          if ($itemContent.attr('data-key') != undefined) {
            var key = $itemContent.attr('data-key');
          } else {
            var key = 'content';
          }
          let content = $itemContent.html();
          content = HELPER.clearExportedData(content);

          // clear content if dynamic field
          // remove long dynamic content
          const $html = jQuery('<div />').html(content);
          $html.find('[data-label="(P) Description"] .module').empty();
          $html.find('[data-label="(A) Content"] .module').empty();
          // clear list item
          $html.find('[data-child-updated="delete"]').remove();
          $html.find('[data-child-updated]').removeAttr('data-child-updated');

          content = $html.html();

          content = content.replace(/script>/g, 'scri-pt>');

          const $activeModule = $itemContent.closest('.module-wrap');
          if ($activeModule.data('gfmodule') != undefined) {
            $activeModule.data('gfmodule').detectModuleChange(index, key, content);
          }
        }
        resolve();
      }, 300);
    });
  },

  detectProductMetaChange: function ($element, content) {
    if ($element.attr('data-label') == '(P) Meta') {
      // SET FLAG WHEN A MATE CHANGES
      $element.attr('data-change', '1');

      const $gfFrame = jQuery('#gfFrame');
      const $gryffBody = $gfFrame.contents().find('body').first();

      const $product = $element.closest('[data-pid]');
      const productId = $product.attr('data-pid');
      const productData = HELPER.searchProductInList(productId);

      let html = '';
      let bkHtml = '';
      let style = '';
      let script = '';
      let libs = [];
      let fonts = [];

      const $html = jQuery('<div />').html(content);
      $html.children('.gf_row, .module-wrap, .element-wrap').each(function () {
        const id = jQuery(this).attr('data-id');

        if ($gryffBody.find('#r-' + id).length) {
          if ($gryffBody.find('#r-' + id).data('gfrow') != undefined) {
            var data = $gryffBody
              .find('#r-' + id)
              .data('gfrow')
              .exportMe();
          }
        } else if ($gryffBody.find('#m-' + id).length) {
          if ($gryffBody.find('#m-' + id).data('gfmodule') != undefined) {
            var data = $gryffBody
              .find('#m-' + id)
              .data('gfmodule')
              .exportMe();
          }
        } else if ($gryffBody.find('#e-' + id).length) {
          if ($gryffBody.find('#e-' + id).data('gfelement') != undefined) {
            var data = $gryffBody
              .find('#e-' + id)
              .data('gfelement')
              .exportMe();
          }
        }

        jQuery(this).replaceWith(data.html);
        bkHtml += data.bkHtml;
        style += data.style;
        script += data.script;
        libs = libs.concat(data.libs);
        fonts = fonts.concat(data.fonts);
      });

      html = $html.html();
      html += '<style type="text/css">' + style + '</style>';
      // libs
      let links = '';
      let libJs = [];
      for (let i = 0; i < libs.length; i++) {
        if (libs[i].indexOf('.css') !== -1) {
          links += '<link rel="stylesheet" type="text/css" href="' + libs[i] + '">';
        } else {
          libJs.push(libs[i]);
        }
      }
      html += links;

      // libjs to html
      libJs = '{ "libs":' + JSON.stringify(libJs) + '}';
      html += '<script class="libs" type="application/json">' + libJs + '</script>';
      html += '<script class="script" type="text/plain">' + script + '</script>';

      if (productData.metafields == undefined || productData.metafields.gempages == undefined) {
        productData.metafields = {
          gempages: {},
        };
      }

      const metaKey =
        $element.children('.module').attr('data-meta') != 'auto'
          ? $element.children('.module').attr('data-meta')
          : $element.attr('data-id');
      productData.metafields.gempages[metaKey] = html;
      productData.metafields.gempages[metaKey + '_bk'] = bkHtml;

      // update
      HELPER.updateProductInList(productData);
    }
    return false;
  },
  /**
   * type:
   *  move: dùng khi kéo 1 element vào bên trong Product element
   *  delete: dùng khi xóa 1 element, đồng thời sẽ xóa luôn trong divContentBk
   *  replace: (chưa biết dùng để làm gì)
   *  new: dùng khi duplicate element
   *  settings: cập nhật các settings có liên quan đến divContentBk
   *  design-options: dùng khi chỉ thay đổi liên quan đến css
   */
  flagListItemChange: function ($targetElement, type) {
    let found = false;

    if (HELPER.isInsideTheList($targetElement)) {
      let $parent = $targetElement;

      if (type != 'delete') {
        if ($parent.closest('[data-label="Product"]').length > 0) {
          while (
            $parent.parent().closest('[data-label]').attr('data-label') != 'Product' &&
            $parent.closest('[data-label="Product"]').length > 0
          ) {
            $parent = $parent.parent().closest('[data-label]');
            found = true;
          }
        } else if (
          $parent.closest('[data-label="Article"]').length > 0 &&
          $parent.closest('[data-label="Article"]').length > 0
        ) {
          while ($parent.parent().closest('[data-label]').attr('data-label') != 'Article') {
            $parent = $parent.parent().closest('[data-label]');
            found = true;
          }
        }
      }

      if (found) {
        $parent.attr('data-child-updated', 'replace');
      } else {
        $targetElement.attr('data-child-updated', type);
      }
    }
    return found;
  },
  detectListItemChange: function ($element) {
    if (HELPER.isInsideTheList($element)) {
      var $module;
      if ($element.closest('[data-label="Product"]').length > 0) {
        var $module = $element.closest('[data-label="Product"]');
      } else if ($element.closest('[data-label="Article"]').length > 0) {
        var $module = $element.closest('[data-label="Article"]');
      }

      if ($module.length > 0) {
        const moduleId = $module.attr('data-id');

        var $productList;
        if ($element.closest('[data-label="Product List"]').length > 0) {
          var $productList = $element.closest('[data-label="Product List"]');
        } else if ($element.closest('[data-label="Related Products"]').length > 0) {
          var $productList = $element.closest('[data-label="Related Products"]');
        } else if ($element.closest('[data-label="Article List"]').length > 0) {
          var $productList = $element.closest('[data-label="Article List"]');
        }

        if ($productList.length > 0) {
          // FLAGGED element
          const $childElement = $productList.find('[data-child-updated]');
          if ($childElement.length > 0) {
            const $gfFrame = jQuery('#gfFrame');
            const $divContentBk = $gfFrame.contents().find('#divContentBk');

            const updateType = $childElement.attr('data-child-updated');
            $childElement.removeAttr('data-child-updated');
            var data = {
              html: '',
              bkHtml: '',
            };
            let elementType = '';
            let elementTypeBk = '';
            if ($childElement.data('gfmodule') != undefined) {
              data = $childElement.data('gfmodule').export('clone');
              elementType = '#m-';
              elementTypeBk = '#module-';
            } else if ($childElement.data('gfelement') != undefined) {
              data = $childElement.data('gfelement').export('clone');
              elementType = '#e-';
              elementTypeBk = '#element-';
            } else if ($childElement.data('gfrow') != undefined) {
              data = $childElement.data('gfrow').export('clone');
              elementType = '#r-';
              elementTypeBk = '#row-';
            }
            const html = data.html;
            const bkHtml = data.bkHtml;

            const childId = $childElement.attr('data-id');
            if (childId != undefined) {
              const regex = /-child(.*?)-/;
              if (childId.match(regex)) {
                var matched = childId.match(regex)[0];
                var matchedString = new RegExp(matched, 'g');
              } else {
                var matchedString = '';
              }
              let childStyle = '';
              switch (updateType) {
                case 'move':
                  var $before = $childElement.prev();
                  while (
                    $before.attr('class') != undefined &&
                    !$before.hasClass('gf_row') &&
                    !$before.hasClass('module-wrap') &&
                    !$before.hasClass('element-wrap')
                  ) {
                    $before = $before.prev();
                  }

                  var beforeId = '';
                  if ($before.length > 0) {
                    beforeId = $before.attr('data-id');
                  }

                  var beforeType = '';
                  if ($before.data('gfmodule') != undefined) {
                    beforeType = '#m-';
                  } else if ($before.data('gfelement') != undefined) {
                    beforeType = '#e-';
                  } else if ($before.data('gfrow') != undefined) {
                    beforeType = '#r-';
                  }
                  break;

                case 'delete':
                  break;

                case 'replace':
                case 'new':
                  var $before = $childElement.prev();

                  while (
                    $before.attr('class') != undefined &&
                    !$before.hasClass('gf_row') &&
                    !$before.hasClass('module-wrap') &&
                    !$before.hasClass('element-wrap')
                  ) {
                    $before = $before.prev();
                  }

                  var beforeId = '';
                  if ($before.length > 0) {
                    beforeId = $before.attr('data-id');
                  }

                  var beforeType = '';
                  if ($before.data('gfmodule') != undefined) {
                    beforeType = '#m-';
                  } else if ($before.data('gfelement') != undefined) {
                    beforeType = '#e-';
                  } else if ($before.data('gfrow') != undefined) {
                    beforeType = '#r-';
                  }

                  break;

                case 'settings':
                  break;

                case 'design-options':
                  switch (elementType) {
                    case '#m-':
                      childStyle = $childElement.data('gfmodule').getModuleCSS();
                      break;

                    case '#e-':
                      childStyle = $childElement.data('gfelement').getElementCSS();
                      break;

                    case '#r-':
                      childStyle = $childElement.data('gfrow').getRowCSS();
                      break;
                  }
                  break;
              }

              var loadDQ = function ($_products, i, length) {
                if (length <= i || length == undefined) {
                  emitter.emit('store:add-async-module-finish', {
                    id: productListId,
                  });
                  return false;
                }
                const $nextProduct = jQuery($_products[i]);
                const index = $nextProduct.attr('data-index');

                const newChildId = childId.replace(matchedString, '-child' + index + '-');
                var $newChild = $nextProduct.find(elementType + newChildId);
                const $gfFrame = jQuery('#gfFrame');
                const $gryffBody = $gfFrame.contents().find('body').first();
                switch (updateType) {
                  // move element inside product element
                  case 'move':
                    if (newChildId != childId) {
                      // NEW: if cant find in another list, then insert.
                      var newBeforeId = beforeId.replace(matchedString, '-child' + index + '-');
                      var $newBefore = $nextProduct.find(beforeType + newBeforeId);

                      $newChild.detach();
                      $newBefore.after($newChild);
                    }
                    break;

                  case 'delete':
                    switch (elementType) {
                      case '#m-':
                        if ($newChild.data('gfmodule') != undefined) {
                          $newChild.data('gfmodule').removeAllChilds();
                        }
                        break;

                      case '#e-':
                        if ($newChild.data('gfelement') != undefined) {
                          $newChild.data('gfelement').deleteDataSettingByKey(newChildId);
                          $newChild.remove();
                        }
                        break;

                      case '#r-':
                        if ($newChild.data('gfrow') != undefined) {
                          $newChild.data('gfrow').removeAllChilds($newChild, 'row');
                        }
                        break;
                    }
                    $newChild.remove();
                    break;

                  case 'replace':
                  case 'new':
                    if (newChildId != childId) {
                      var newHtml = html;
                      var newBkHtml = bkHtml;

                      // NEW: if cant find in another list, then insert.
                      var newBeforeId = beforeId.replace(matchedString, '-child' + index + '-');
                      var $newBefore = $nextProduct.find(beforeType + newBeforeId);

                      const regex = /-child(.*?)-/;
                      if (newHtml.match(regex)) {
                        var matched1 = newHtml.match(regex)[0];
                        var matchedString1 = new RegExp(matched, 'g');

                        newHtml = newHtml.replace(matchedString1, '-child' + index + '-');
                        newBkHtml = newBkHtml.replace(matchedString1, '-child' + index + '-');
                      }

                      if (updateType == 'replace') {
                        $newChild.remove();
                      }

                      if ($newBefore.length > 0) {
                        $newBefore.after(newHtml);
                        HELPER.addContentBk(newBkHtml);

                        // switch (elementType) {
                        //     case '#m-':
                        //         $newBefore.next().gfModule();
                        //         break;

                        //     case '#e-':
                        //         $newBefore.next().gfElement();
                        //         break;

                        //     case '#r-':
                        //         $newBefore.next().gfRow();
                        //         break;
                        // }
                        atom.Init($newBefore.next());
                      } else {
                        let $itemContent;
                        const $childrenForm = $nextProduct.children('div.module').children('form');
                        const $nextProductForm = $childrenForm.length
                          ? $childrenForm
                          : $nextProduct.children('div.module').find('form');
                        if ($nextProductForm.children('.item-content').length > 0) {
                          $itemContent = $nextProductForm.children('.item-content');
                        } else if ($nextProduct.children('div.module').children('.item-content').length > 0) {
                          $itemContent = $nextProduct.children('div.module').children('.item-content');
                        }

                        if ($itemContent && $itemContent.length > 0) {
                          $itemContent.prepend(newHtml);
                          HELPER.addContentBk(newBkHtml);

                          switch (elementType) {
                            case '#m-':
                              // $itemContent.find('.module-wrap:first').gfModule();
                              atom.Init($itemContent.find('.module-wrap:first'));
                              break;

                            case '#e-':
                              // $itemContent.find('.element-wrap:first').gfElement();
                              atom.Init($itemContent.find('.element-wrap:first'));
                              break;

                            case '#r-':
                              // $itemContent.find('.gf_row:first').gfRow();
                              atom.Init($itemContent.find('.gf_row:first'));
                              break;
                          }
                        }
                      }
                    }
                    break;

                  case 'settings':
                    if (newChildId != childId) {
                      if (html.match(childId)) {
                        var matched1 = html.match(childId)[0];
                        var matchedString1 = new RegExp(matched1, 'g');
                      }
                      var newHtml = html.replace(matchedString1, newChildId);

                      if (bkHtml.match(childId)) {
                        var matched1 = bkHtml.match(childId)[0];
                        var matchedString1 = new RegExp(matched1, 'g');
                      }
                      var newBkHtml = bkHtml.replace(matchedString1, newChildId);

                      // html
                      $gryffBody.find(elementType + newChildId).replaceWith(newHtml);
                      // bkhtml
                      if (elementTypeBk) {
                        const keyTypeBk = elementTypeBk.replace('#', '').replace('-', '');
                        HELPER.deleteDataSetting(keyTypeBk, newChildId);
                      }
                      HELPER.addContentBk(newBkHtml);

                      var $newChild = $nextProduct.find(elementType + newChildId);
                      switch (elementType) {
                        case '#m-':
                          // $newChild.gfModule();
                          atom.Init($newChild);
                          break;

                        case '#e-':
                          // $newChild.gfElement();
                          atom.Init($newChild);
                          break;

                        case '#r-':
                          // $newChild.gfRow();
                          atom.Init($newChild);
                          break;
                      }
                    }
                    break;

                  case 'design-options':
                    if (newChildId != childId) {
                      if (childStyle.match(childId)) {
                        var matched1 = childStyle.match(childId)[0];
                        var matchedString1 = new RegExp(matched1, 'g');
                      }
                      const newChildStyle = childStyle.replace(matchedString1, newChildId);

                      switch (elementType) {
                        case '#m-':
                          if ($newChild.data('gfmodule') != undefined) {
                            $newChild.data('gfmodule').runStyle(newChildStyle);
                          }
                          break;

                        case '#e-':
                          if ($newChild.data('gfelement') != undefined) {
                            $newChild.data('gfelement').runStyle(newChildStyle);
                          }
                          break;

                        case '#r-':
                          if ($newChild.data('gfrow') != undefined) {
                            $newChild.data('gfrow').runStyle(newChildStyle);
                          }
                          break;
                      }
                    }
                    break;
                }
                setTimeout(function () {
                  i++;
                  return loadDQ($_products, i, length);
                }, 50);
              };

              if ($productList.find('[data-label="Product"]').length > 0) {
                var $_products = $productList.find('[data-label="Product"]');
              } else {
                var $_products = $productList.find('[data-label="Article"]');
              }

              const length = $_products.length;
              loadDQ($_products, 0, length);
            }

            var data = $module.data('gfmodule').export('clone');

            const rData = HELPER.replaceIds(data.html, data.bkHtml);
            var html1 = rData.html;
            var bkHtml1 = rData.bkHtml;

            var html1 = html1.replace(/script/g, 'scri-pt');
            html1 = HELPER.simpleEscape(html1);

            var bkHtml1 = bkHtml1.replace(/script/g, 'scri-pt');
            bkHtml1 = HELPER.simpleEscape(bkHtml1);
            const productListId = $productList.data('gfmodule').getModuleId();

            const keyTemplateChildHtml = this.getKeyDataSetting(base._templateChildHtml, productListId, 'module');
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keyTemplateChildHtml,
              value: html1,
            });

            const keyTemplateChildBkHtml = this.getKeyDataSetting(base._templateChildBkHtml, productListId, 'module');
            app.$store.commit('editor/SET_DATA_SETTINGS', {
              id: keyTemplateChildBkHtml,
              value: bkHtml1,
            });
          }
        }
      }
    }
    return false;
  },

  deleteDataSetting: function (keyTypeBk, attrId) {
    app.$store.commit('editor/DELETE_DATA_SETTING_BY_KEY', {
      keyType: keyTypeBk,
      attrId: attrId,
      data: {
        [base._style]: true,
        [base._template]: true,
        [base._snippet]: true,
        [base._libs]: true,
        [base._data]: true,
        [base._script]: true,
        [base._settings]: true,
        [base._interactions]: true,
        [base._actions]: true,
        [base._actionsStyle]: true,
        [base._templateChildHtml]: true,
        [base._templateChildBkHtml]: true,
      },
    });
    const $gfFrameContents = jQuery('#gfFrame').contents();
    if (keyTypeBk == 'row') {
      const $rowStyleContainer = $gfFrameContents.find('#' + rowTypes._rowStyleContainer);
      const $style = $rowStyleContainer.find('#' + base._style + '-' + attrId);
      $style.remove();
    }
    if (keyTypeBk == 'column') {
      const $columnStyleContainer = $gfFrameContents.find('#' + rowTypes._column$columnStyleContainer);
      const $style = $columnStyleContainer.find('#' + base._style + '-' + attrId);
      $style.remove();
    }
    if (keyTypeBk == 'element') {
      const $elementStyleContainer = $gfFrameContents.find('#' + elementTypes._elementStyleContainer);
      const $style = $elementStyleContainer.find('#' + base._style + '-' + attrId);
      $style.remove();
    }
    if (keyTypeBk == 'module') {
      const $moduleStyleContainer = $gfFrameContents.find('#' + moduleTypes._moduleStyleContainer);
      const $moduleScriptContainer = $gfFrameContents.find('#' + moduleTypes._moduleScriptContainer);
      const $style = $moduleStyleContainer.find('#' + base._style + '-' + attrId);
      $style.remove();
      const $script = $moduleScriptContainer.find('#' + base._script + '-' + attrId);
      $script.remove();
    }
    return;
  },

  getImageBg: function ($element) {
    var backgroundImg = $element.css('background-image');
    if (backgroundImg != undefined) {
      var backgroundImg = backgroundImg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
      if (backgroundImg != 'none') {
        return backgroundImg;
      }
    }
    return '';
  },
  getImageBgOption: function (url) {
    if (url != '') {
      url = 'url(' + url + ')';
    }
    return url;
  },
  // wt7u85bt9w
  sortObject: function (object) {
    let sorted = {},
      key,
      a = [];

    for (key in object) {
      if (object.hasOwnProperty(key)) {
        a.push(key);
      }
    }
    a.sort(function (i, j) {
      return i.length - j.length;
    });
    for (key = 0; key < a.length; key++) {
      sorted[a[key]] = object[a[key]];
    }
    return sorted;
  },
  // bk75ptq3td
  compressHTML: function (html) {
    return html.replace(/^\s+|\r\n|\n|\r|(>)\s+(<)|\s+$/gm, '$1$2');
  },
  // 7pbu92te59
  getClassList: function (classes) {
    const classList = classes.split(/\s+/);
    return classList;
  },
  // zyn9gtxk4r
  formatJsonHtml: function (html) {
    if (!html) return '';
    let newHTML = html.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/\n/, '');
    //newHTML = html.replace(/}/g, "}111/t");
    while (newHTML.indexOf(' ') == 0) {
      newHTML = newHTML.replace(/^\s/gm, '');
    }
    return newHTML;
  },
  formatHtml: function (html) {
    const tab = '\t';
    let result = '';
    let indent = '';

    html.split(/>\s*</).forEach(function (element) {
      if (element.match(/^\/\w/)) {
        indent = indent.substring(tab.length);
      }

      result += indent + '<' + element + '>\r\n';

      if (element.match(/^<?\w[^>]*[^\/]$/) && !element.startsWith('input')) {
        indent += tab;
      }
    });

    return result.substring(1, result.length - 3);
  },
  // jhg7vy5khb
  refreshFrame: function () {
    if (window._gRefreshFrame) {
      return;
    }
    const $gfFrame = jQuery('#gfFrame');
    const oldHeight = $gfFrame.height();
    const newHeight = oldHeight + 10;
    $gfFrame.height(newHeight);
    window._gRefreshFrame = setTimeout(function () {
      $gfFrame.height(oldHeight);
      window._gRefreshFrame = null;
    }, 100);
    return false;
  },
  refreshEqualHeight: function () {
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $equal = $gryffBody.find('.gf_equal-height');
    $equal.children('.gf_column').css('min-height', 'auto');
  },
  getLibs: function (obj) {
    const $gfFrame = jQuery('#gfFrame');
    if (!obj.hasOwnProperty('urls') || obj.urls.length === 0) {
      if (obj.hasOwnProperty('start') && typeof obj.start === 'function') {
        obj.start();
      }
      if (obj.hasOwnProperty('done') && typeof obj.done === 'function') {
        obj.done();
      }
      if (obj.hasOwnProperty('complete') && typeof obj.complete === 'function') {
        obj.complete();
      }
    } else {
      if (obj.hasOwnProperty('start') && typeof obj.start === 'function') {
        obj.start();
      }
      let urls = obj.urls,
        loaded = 0;

      for (let i = 0; i < urls.length; i++) {
        if (urls[i].indexOf('.css') !== -1) {
          const styleTag = '<link href="' + urls[i] + '" rel="stylesheet" type="text/css"/>';
          $gfFrame.contents().find('head').append(styleTag);
          loaded += 1;
        } else if (urls[i].indexOf('.js') !== -1) {
          HELPER.getJSFile({
            src: urls[i],
            success: function () {
              loaded += 1;
              if (loaded === urls.length) {
                if (obj.hasOwnProperty('done') && typeof obj.done === 'function') {
                  obj.done();
                }
                if (obj.hasOwnProperty('complete') && typeof obj.complete === 'function') {
                  obj.complete();
                }
              }
            },
            error: function () {
              if (obj.hasOwnProperty('error') && typeof obj.error === 'function') {
                obj.error();
              }
              if (obj.hasOwnProperty('complete') && typeof obj.complete === 'function') {
                obj.complete();
              }
            },
            block: function () {
              console.log(obj);
              if (obj.hasOwnProperty('block') && typeof obj.block === 'function') {
                obj.block();
              }
            },
          });
        }
      }
    }
    return false;
  },
  clearExportedData: function (html) {
    const $html = jQuery('<div />').html(html);

    $html
      .find(
        '.gf-tool, .gf_add-content,.module-loading, #md-editor-tool, .block-placeholder, .gf-outline, .gf-margin, .gf_content-layouts, .drag-hidden',
      )
      .remove();
    // Row, Module, Element
    $html.find('.gf_row, .module-wrap, .element-wrap').removeClass('ui-draggable ui-sortable');
    // Text Editor
    $html.find('[contenteditable="true"]').each(function () {
      jQuery(this).removeAttr('contenteditable');
      jQuery(this).removeClass('text-editing');
    });
    var html = $html.html();

    return html;
  },

  // LAZYLOADING2019
  replaceImageSource: function (src) {
    const expectImageSize = '120x120';
    const isUcare = src.indexOf('ucarecdn.com/') != -1;
    const isShopifyCdn = src.indexOf('cdn.shopify.com/s/files/') != -1;
    const isShopifyCdn2 = src.indexOf('apps.shopifycdn.com/') != -1;

    if (isUcare || isShopifyCdn || isShopifyCdn2) {
      let shopifyRegex = /_\d+x?\d*\.(png|jpg|jpe|jpeg|bmp|gif|web|bpg)/i;
      let shopifyRegex2 = /_\d*x?\d+\.(png|jpg|jpe|jpeg|bmp|gif|web|bpg)/i;
      if (checkKeyValid('checkReplaceShopifyImageSource')) {
        shopifyRegex = /_\d+x\d*\.(png|jpg|jpe|jpeg|bmp|gif|web|bpg)/i;
        shopifyRegex2 = /_\d*x\d+\.(png|jpg|jpe|jpeg|bmp|gif|web|bpg)/i;
      }
      const ucareRegex = /preview\/\d+x?\d*/i;

      var oldImageSize =
        isShopifyCdn || isShopifyCdn2 ? shopifyRegex.exec(src) || shopifyRegex2.exec(src) : ucareRegex.exec(src);
      let oldImageTail = '0x0'; // _120x120.jpg
      try {
        if (oldImageSize) {
          oldImageTail = oldImageSize[0];
          oldImageSize = isShopifyCdn || isShopifyCdn2 ? oldImageTail.slice(1).split('.')[0] : oldImageTail.slice(8); // 120x120
        }
      } catch (e) {
        console.error(e);
        return {
          src: src,
          oriSize: null,
        };
      }

      if (!oldImageSize) {
        oldImageSize = '0x0';
      }

      if (parseInt(oldImageSize.split('x')[0]) > parseInt(expectImageSize.split('x')[0])) {
        if ((isShopifyCdn || isShopifyCdn2) && oldImageSize == '0x0') {
          src = src.replace(/.png/i, '_' + expectImageSize + '.png');
          src = src.replace(/.jpg/i, '_' + expectImageSize + '.jpg');
          src = src.replace(/.jpeg/i, '_' + expectImageSize + '.jpeg');
          src = src.replace(/.bmp/i, '_' + expectImageSize + '.bmp');
          src = src.replace(/.gif/i, '_' + expectImageSize + '.gif');
          src = src.replace(/.webp/i, '_' + expectImageSize + '.webp');
          src = src.replace(/.bpg/i, '_' + expectImageSize + '.bpg');
        } else {
          if (isShopifyCdn || isShopifyCdn2) {
            var newImageTail = oldImageTail.replace(oldImageSize, expectImageSize); // _1200x1200.jpg
            if (shopifyRegex.test(src)) {
              src = src.replace(shopifyRegex, newImageTail);
            } else {
              src = src.replace(shopifyRegex2, newImageTail);
            }
          } else {
            var newImageTail = oldImageTail.replace(oldImageSize, expectImageSize); // /preview/1200x1200
            src = src.replace(ucareRegex, newImageTail);
          }
        }
      }
    } else if (src.indexOf('img_url') != -1) {
      var oldImageSize = /\d+x\d+/i.exec(src);

      if (oldImageSize) {
        oldImageSize = oldImageSize[0];
      } else {
        oldImageSize = '0x0';
      }

      if (parseInt(oldImageSize.split('x')[0]) > parseInt(expectImageSize.split('x')[0])) {
        src = src.replace(oldImageSize, expectImageSize);
        // keep the image_url branch (convertImgUrlToImageUrl) in sync with the placeholder size
        src = src.replace(/image_url:\s*width:\s*\d+/g, `image_url: width: ${parseInt(expectImageSize)}`);
      }
    }
    const oriSizeDimension = parseInt(oldImageSize) || parseInt(oldImageSize.replace('x', '')) || null;
    const oriSize = oriSizeDimension ? oriSizeDimension + 'x' + oriSizeDimension : null;

    return {
      src: src,
      oriSize: oriSize,
    };
  },

  // LAZYLOADING2019
  applyLazyLoad: function (html) {
    const lazyload = jQuery('#gfFrame').data('gfframe').getPageLazyload();
    const $html = jQuery('<div />').html(html);

    const excludes = ['Popup'];
    const checkExcludes = function ($el) {
      let excludeCount = 0;
      for (let i = 0; i < excludes.length; i++) {
        if ($el.parents('[data-label="' + excludes[i] + '"], .gf_nolazyload').length != 0) {
          excludeCount++;
        }
      }
      return excludeCount > 0;
    };
    const checkAcceptLazyloadImage = function (imgSrc) {
      if (!imgSrc) {
        return false;
      }
      /**
       * GIF Uploadcare return the url without size filter like this:
       * https://ucarecdn.com/884ec189-bd22-4793-9323-fc4078ef2218/
       * so do not add resolution to this url
       */
      const isGifUcare = hasImageUploadCare(imgSrc) && !imgSrc.includes('preview/');
      if (isGifUcare) {
        return false;
      }

      /**
       * Ignore svg image from shopify cdn
       */
      const imgExtension = getFileExtensionFromSource(imgSrc);
      const isSvgShopifyCDN = hasImageShopify(imgSrc) && imgExtension == 'svg';
      if (isSvgShopifyCDN) {
        return false;
      }

      return true;
    };

    $html.find('img').each(function (index, el) {
      const src = jQuery(el).attr('src');

      if (!lazyload || checkExcludes(jQuery(el)) || !checkAcceptLazyloadImage(src)) {
        jQuery(el).removeClass('gf_lazyload');
        jQuery(el).removeClass('gf_lazyloaded');
        jQuery(el).removeAttr('data-lg-size');
      } else {
        if (
          src.indexOf('ucarecdn.com/') != -1 ||
          src.indexOf('cdn.shopify.com/s/files/') != -1 ||
          src.indexOf('apps.shopifycdn.com/') != -1
        ) {
          jQuery(el).addClass('gf_lazyload');
          const srcData = HELPER.replaceImageSource(src);

          jQuery(el).attr('src', srcData.src);
          if (srcData.oriSize) {
            jQuery(el).attr('data-lg-size', srcData.oriSize);
          } else {
            jQuery(el).removeAttr('data-lg-size');
          }
        }
      }
    });

    //testing function convertProductFormHtmlToLiquid
    if (checkKeyValid('fixOldPImageLazyload')) {
      $html.find('div[data-label="(P) Image"]').each(function (index, el) {
        const $img = jQuery(el).find('.module img');
        $img.attr('natural-width', '{{ featured_image.width }}');
        $img.attr('natural-height', '{{ featured_image.height }}');
      });
    }

    // no need to check Product List & Related Products
    $html
      .find('div[data-label="Product"], div[data-label="Article List"]')
      .find('img')
      .each(function (index, el) {
        var src = jQuery(el).attr('src');

        if (!lazyload || checkExcludes(jQuery(el)) || !checkAcceptLazyloadImage(src)) {
          jQuery(el).removeClass('gf_lazyload');
          jQuery(el).removeClass('gf_lazyloaded');
          jQuery(el).removeAttr('data-lg-size');
        } else {
          var src = jQuery(el).attr('src');

          if (src.indexOf('img_url') != -1) {
            jQuery(el).addClass('gf_lazyload');

            const srcData = HELPER.replaceImageSource(src);

            jQuery(el).attr('src', srcData.src);
            if (srcData.oriSize) {
              jQuery(el).attr('data-lg-size', srcData.oriSize);
            } else {
              jQuery(el).removeAttr('data-lg-size');
            }
          }
        }
      });

    $html.find('div[data-label="Parallax"]').each(function (index, el) {
      const $lazyLoadHolder = jQuery(el).find('.gf_parallax-bg');
      const $module = jQuery(el).find('.module');
      const src = $module.data('image');

      if (!lazyload || checkExcludes(jQuery(el)) || !checkAcceptLazyloadImage(src)) {
        $lazyLoadHolder.removeClass('gf_lazyload');
        $lazyLoadHolder.removeClass('gf_lazyloaded');
        $lazyLoadHolder.removeAttr('data-lg-size');
      } else {
        if (
          src.indexOf('ucarecdn.com/') != -1 ||
          src.indexOf('cdn.shopify.com/s/files/') != -1 ||
          src.indexOf('apps.shopifycdn.com/') != -1
        ) {
          const srcData = HELPER.replaceImageSource(src);

          $lazyLoadHolder.addClass('gf_lazyload');
          if (srcData.oriSize) {
            $lazyLoadHolder.attr('data-lg-size', srcData.oriSize);
          } else {
            $lazyLoadHolder.removeAttr('data-lg-size');
          }

          $module.attr('data-image', srcData.src);
        }
      }
    });

    $html.find('div[data-label="Hero Banner"]').each(function (index, el) {
      const $module = jQuery(el).children('.module');

      // fixed mode works as a single image
      if ($module.attr('data-fixedMode') == '1') {
        jQuery(el).removeClass('gf_lazyload');
        jQuery(el).removeClass('gf_lazyloaded');
        jQuery(el).removeAttr('data-lg-size');

        return;
      }

      const src = $module.data('image');

      if (!lazyload || checkExcludes(jQuery(el)) || !checkAcceptLazyloadImage(src)) {
        jQuery(el).removeClass('gf_lazyload');
        jQuery(el).removeClass('gf_lazyloaded');
        jQuery(el).removeAttr('data-lg-size');
        jQuery(el)[0].style.backgroundImage = '';
      } else {
        if (
          src.indexOf('ucarecdn.com/') != -1 ||
          src.indexOf('cdn.shopify.com/s/files/') != -1 ||
          src.indexOf('apps.shopifycdn.com/') != -1
        ) {
          const srcData = HELPER.replaceImageSource(src);

          jQuery(el).addClass('gf_lazyload');
          if (srcData.oriSize) {
            jQuery(el).attr('data-lg-size', srcData.oriSize);
          } else {
            jQuery(el).removeAttr('data-lg-size');
          }

          $module.attr('data-image', srcData.src);
        }
      }
    });

    $html.find('div[data-label="Instagram"]').each(function (index, el) {
      const $module = $(el).find('.module');
      if (!lazyload || checkExcludes($(el))) {
        $module.removeClass('gf_lazyload-insta');
      } else {
        $module.addClass('gf_lazyload-insta');
      }
    });

    if (!lazyload) {
      // make sure there is no lazyload class
      $html.find('.gf_lazyload, .gf_lazyloaded, [data-lg-size]').each(function () {
        jQuery(this).removeClass('gf_lazyload').removeClass('gf_lazyloaded').removeAttr('data-lg-size');
      });
    }

    var html = $html.html();
    html = HELPER.simpleHTMLEntities(html);
    return html;
  },

  convertToSlug: function (text) {
    return text
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
  },
  formatCSS: function (css, compress) {
    if (!css) {
      return css;
    }
    css = css
      .replace(/\/\*(.*)\*\/|\n/g, '')
      .replace(/\t/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\s\{|\{\s/g, '{')
      .replace(/\}\s|\s\}/g, '}')
      .replace(/\;\s|\s\;/g, ';')
      .replace('undefined', '')
      .trim();

    if (compress === true) {
      return css;
    }
    const tabs = ['', '\t', '\t\t', '\t\t\t', '\t\t\t\t', '\t\t\t\t\t', '\t\t\t\t\t\t'];
    let num = 0;
    let len = css.length;
    // if (process.env.NODE_ENV != "production") {
    //   console.time("slice time");
    // }
    for (let i = 0; i < len; i++) {
      if (css[i] == '{') {
        num++;
        if (css[i + 1] == '}') {
          css = css.slice(0, i + 1) + '\n' + tabs[num - 1] + css.slice(i + 1);
          len += num;
          i += num - 1;
        } else {
          css = css.slice(0, i + 1) + '\n' + tabs[num] + css.slice(i + 1);
          len += num + 1;
          i += num;
        }
      } else if (css[i] == '}') {
        num--;
        if (css[i + 1] == '}') {
          css = css.slice(0, i + 1) + '\n' + tabs[num - 1] + css.slice(i + 1);
          len += num;
          i += num - 1;
        } else {
          css = css.slice(0, i + 1) + '\n' + tabs[num] + css.slice(i + 1);
          len += num + 1;
          i += num;
        }
      } else if (css[i] == ';') {
        if (css[i + 1] == '}') {
          css = css.slice(0, i + 1) + '\n' + tabs[num - 1] + css.slice(i + 1);
          len += num;
          i += num - 1;
        } else {
          css = css.slice(0, i + 1) + '\n' + tabs[num] + css.slice(i + 1);
          len += num + 1;
          i += num;
        }
      }
    }
    // if (process.env.NODE_ENV != "production") {
    //   console.timeEnd("slice time");
    // }
    return css;
  },
  formatCode: function (s) {
    //format template and script
    if (!s) return '';

    //trim string before
    s = s.trim();

    let rm = '';
    for (let i = 0; i < s.length; i++) {
      if (s[i] == '\n' || s[i] == '\r') {
        rm = '';
      } else if (s[i] == ' ' || s[i] == '\t') {
        rm += s[i];
      } else {
        break;
      }
    }
    const re = new RegExp(rm, 'g');
    s = s.replace(re, '').trim();

    return s;
  },
  _rebuild: function (obj) {
    const n_formdata = {};
    if (typeof obj === 'object') {
      n_formdata.type = 'group';
      n_formdata.items = obj;
      $.each(n_formdata.items, function (key, val) {
        if (!val.hasOwnProperty('default_value')) {
          val.default_value = '';
          n_formdata.items[key].default_value = '';
        } else {
          n_formdata.items[key].value = val.default_value;
        }

        /* !!!!NOTICE: Support For Old Modules */
        if (val.type === 'align') {
          if (!val.hasOwnProperty('options')) {
            n_formdata.items[key]['options'] = {
              left: 'Left',
              right: 'Right',
              center: 'Center',
            };
          }
          n_formdata.items[key].type = 'select';

          if (typeof val.options[val.default_value] != 'undefined') {
            n_formdata.items[key].options[val.default_value] = {
              selected: 'selected',
              html: val.options[val.default_value],
            };
          }
          if (!n_formdata.items[key].hasOwnProperty('class')) n_formdata.items[key].class = '';
          n_formdata.items[key].class += ' gf_to-align';
        } else if (val.type === 'switch') {
          if (!val.hasOwnProperty('data-on')) n_formdata.items[key]['data-on'] = '1';
          if (!val.hasOwnProperty('data-off')) n_formdata.items[key]['data-off'] = '0';

          n_formdata.items[key].type = 'text';

          n_formdata.items[key].value = val.default_value;

          if (!n_formdata.items[key].hasOwnProperty('class')) n_formdata.items[key].class = '';
          n_formdata.items[key].class += ' gf_to-switch';
        } else if (val.type === 'range') {
          n_formdata.items[key].type = 'text';
          n_formdata.items[key].value = val.default_value;
          if (!n_formdata.items[key].hasOwnProperty('class')) n_formdata.items[key].class = '';
          n_formdata.items[key].class += ' gf_to-range';
        } else if (val.type === 'upload') {
          n_formdata.items[key].type = 'text';
          n_formdata.items[key].value = val.default_value;
          if (!n_formdata.items[key].hasOwnProperty('class')) n_formdata.items[key].class = '';
          n_formdata.items[key].class += ' gf_to-photoPicker';
        } else if (val.type === 'color') {
          n_formdata.items[key].type = 'text';
          n_formdata.items[key].value = val.default_value;
          n_formdata.items[key]['data-alpha'] = 'true';
          n_formdata.items[key]['data-type'] = 'hidden';
          if (!n_formdata.items[key].hasOwnProperty('class')) n_formdata.items[key].class = '';
          n_formdata.items[key].class += ' gryff-color';
        } else if (val.type === 'font') {
          n_formdata.items[key].type = 'text';
          n_formdata.items[key].value = val.default_value;
          if (!n_formdata.items[key].hasOwnProperty('class')) n_formdata.items[key].class = '';
          n_formdata.items[key].class += ' gf_font';
        } else if (
          val.type === 'text' ||
          val.type === 'password' ||
          val.type === 'submit' ||
          val.type === 'reset' ||
          val.type === 'hidden' ||
          val.type === 'file' ||
          val.type === 'number' ||
          val.type === 'url' ||
          val.type === 'tel' ||
          val.type === 'email'
        ) {
          n_formdata.items[key].value = val.default_value;
        } else if (val.type === 'select') {
          if (typeof val.options[val.default_value] != 'undefined') {
            n_formdata.items[key].options[val.default_value] = {
              selected: 'selected',
              html: val.options[val.default_value],
            };
          }
        } else if (val.type === 'radiobuttons' || val.type === 'checkboxes') {
          if (typeof val.options[val.default_value] != 'undefined') {
            n_formdata.items[key].options[val.default_value] = {
              checked: 'checked',
              caption: val.options[val.default_value],
            };
          }
        } else if (val.type === 'checkbox') {
          if (val.default_value === true || val.default_value === 'true') {
            val.checked = 'checked';
          }
        } else if (val.type === 'datepicker') {
          n_formdata.items[key].type = 'text';
          n_formdata.items[key].value = val.default_value;
          if (!n_formdata.items[key].hasOwnProperty('class')) n_formdata.items[key].class = '';
          n_formdata.items[key].class += ' gf_to-datePicker';
        }
      });
    }
    return n_formdata;
  },
  getJSFile: function (obj, force) {
    const _cacheLib = [];
    if (force == undefined) {
      var force = false;
    } else {
      var force = true;
    }
    let cached = false;

    if (!force) {
      for (let i = 0; i < _cacheLib.length; i++) {
        if (obj.src === _cacheLib[i].src) {
          cached = true;
          if (obj.success && typeof obj.success === 'function') {
            obj.success();
          }
          break;
        }
      }
    }

    if (cached === false) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null;

            if (obj.success && typeof obj.success === 'function') {
              obj.success();
            }
            if (_cacheLib.length) {
              for (let i = 0; i < _cacheLib.length; i++) {
                if (obj.src === _cacheLib[i].src && _cacheLib[i].scriptData != '') {
                  break;
                } else if (i === _cacheLib.length - 1) {
                  _cacheLib.push({
                    src: obj.src,
                  });
                }
              }
            } else {
              _cacheLib.push({
                src: obj.src,
              });
            }
          }
        };
      } else {
        script.onload = function () {
          if (obj.success && typeof obj.success === 'function') {
            obj.success();
          }
          if (_cacheLib.length) {
            for (let i = 0; i < _cacheLib.length; i++) {
              if (obj.src === _cacheLib[i].src && _cacheLib[i].scriptData != '') {
                break;
              } else if (i === _cacheLib.length - 1) {
                _cacheLib.push({
                  src: obj.src,
                });
              }
            }
          } else {
            _cacheLib.push({
              src: obj.src,
            });
          }
        };
      }
      script.src = obj.src;

      if (obj.previewFrame != undefined) {
        document
          .getElementById('gfPreviewFrame')
          .contentWindow.document.getElementsByTagName('head')[0]
          .appendChild(script);
      } else {
        document.getElementById('gfFrame').contentWindow.document.getElementsByTagName('head')[0].appendChild(script);
      }

      /**
       * trường hợp bị cookieyes chặn
       */
      if (script.getAttribute('type') == 'javascript/blocked') {
        if (obj.block && typeof obj.block === 'function') {
          obj.block();
        }
      }
    }
  },
  generateIds: function (idList) {
    const newIdList = [];
    while (newIdList.length < idList.length) {
      const newId = HELPER.MakeId();
      if (jQuery.inArray(newId, newIdList) === -1) {
        newIdList.push(newId);
      }
    }

    return newIdList;
  },
  replaceIds: function (html, bkHtml, newLoopId) {
    if (globalBkHtml == undefined) {
      var globalBkHtml = '';
    }
    if (globalStyle == undefined) {
      var globalStyle = '';
    }
    if (globalScript == undefined) {
      var globalScript = '';
    }
    const $tmpHtml = jQuery('<div />').html(html);

    const idList = [];
    let loopId;
    $tmpHtml.find('[data-label][data-id]').each(function () {
      const id = jQuery(this).attr('data-id');
      idList.push(id);

      // Product List
      // Related Products
      // Article List
      if (jQuery(this).attr('data-label') == 'Product' || jQuery(this).attr('data-label') == 'Article') {
        loopId = id;
      }
    });
    const newIdList = HELPER.generateIds(idList);

    for (let i = 0; i < idList.length; i++) {
      const oldId = idList[i];
      const matchedString = new RegExp(oldId, 'g');

      if (loopId != undefined && newLoopId != undefined && loopId == oldId) {
        html = html.replace(matchedString, newLoopId);
        bkHtml = bkHtml.replace(matchedString, newLoopId);
      } else {
        const newId = newIdList[i];
        html = html.replace(matchedString, newId);
        bkHtml = bkHtml.replace(matchedString, newId);
      }
    }
    return {
      html: html,
      bkHtml: bkHtml,
    };
  },
  convertToValueAndUnit: function (value) {
    let data;
    if (!value) {
      data = {
        value: '',
        unit: 'px',
      };
      return data;
    } else if (value == 'auto' || value == '') {
      data = {
        value: value,
        unit: null,
      };
      return data;
    } else {
      if (value.indexOf('px') >= 0) {
        data = {
          value: value.slice(0, value.indexOf('px')),
          unit: 'px',
        };
      } else if (value.indexOf('%') >= 0) {
        data = {
          value: value.slice(0, value.indexOf('%')),
          unit: '%',
        };
      } else if (value.indexOf('em') >= 0) {
        data = {
          value: value.slice(0, value.indexOf('em')),
          unit: 'em',
        };
      } else {
        data = {
          value: value,
          unit: false,
        };
      }
      return data;
    }
  },

  htmlDecode: function (input) {
    let parsedInput = input;
    parsedInput = parsedInput
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"');
    return parsedInput;
  },

  changeImageResolution: function (src, size) {
    if (
      src.indexOf('ucarecdn.com/') != -1 ||
      src.indexOf('cdn.shopify.com/s/files/') != -1 ||
      src.indexOf('apps.shopifycdn.com/') != -1
    ) {
      const shopifyRegex = /_\d+x?\d*\.(png|jpg|jpe|bmp|gif|web|bpg)/i;
      const ucareRegex = /preview\/\d+x?\d*/i;

      let oldImageSize =
        src.indexOf('cdn.shopify.com/') != -1 || src.indexOf('apps.shopifycdn.com') != -1
          ? shopifyRegex.exec(src)
          : ucareRegex.exec(src);
      if (oldImageSize) {
        oldImageSize =
          src.indexOf('cdn.shopify.com/') != -1 || src.indexOf('apps.shopifycdn.com') != -1
            ? oldImageSize[0].slice(1, -4)
            : oldImageSize[0].slice(8);
      }
      if (!oldImageSize) {
        oldImageSize = '0x0';
      }

      const expectImageSize = size + 'x' + size;

      if (
        (src.indexOf('cdn.shopify.com/s/files/') != -1 || src.indexOf('apps.shopifycdn.com/') != -1) &&
        oldImageSize == '0x0'
      ) {
        src = src.replace(/.png/gi, '_' + expectImageSize + '.png');
        src = src.replace(/.jpg/gi, '_' + expectImageSize + '.jpg');
        src = src.replace(/.jpeg/gi, '_' + expectImageSize + '.jpeg');
        src = src.replace(/.bmp/gi, '_' + expectImageSize + '.bmp');
        src = src.replace(/.gif/gi, '_' + expectImageSize + '.gif');
        src = src.replace(/.webp/gi, '_' + expectImageSize + '.webp');
        src = src.replace(/.bpg/gi, '_' + expectImageSize + '.bpg');
      } else {
        src = src.replace(oldImageSize, expectImageSize);
      }
    }

    return src;
  },

  canSplitContent: function (html) {
    const moduleArr = html.split('<!--gfsplit-->');

    // Get the id atribute of module
    const pattern1 = /id=["'][\w\-]+["']/;

    // Get the id of module
    const pattern2 = /\w{1}-\d+/;

    // Remove data-background of swatches
    const pattern3 = /data-background="([^"]*)"/g;
    const isRemoveDataBG = checkKeyValid('enableRemoveDataBackgroundSwatches');

    for (let i = 0; i < moduleArr.length; i++) {
      const newHtml = isRemoveDataBG ? moduleArr[i].replace(pattern3, 'data-background=""') : moduleArr[i];
      const byteSize = new Blob([newHtml]).size;
      if (byteSize > 230000) {
        let id = pattern2.exec(pattern1.exec(newHtml));
        if (id && id.length) {
          id = id[0];
        }
        return {
          status: false,
          id: id,
        };
      }
    }
    return {
      status: true,
    };
  },
  // Disable or reset state actions on TopBar
  disabledAllAction: function () {
    jQuery('#gf-save').addClass('gf-disabled_action');
    jQuery('#gf-preview').addClass('gf-disabled_action');
    jQuery('#gf-publish').addClass('gf-disabled_action');
    jQuery('#gf-view').addClass('gf-disabled_action');
  },
  enabledAllAction: function (enabledViewlive = true, enabledPreview = true) {
    jQuery('#gf-save').removeClass('gf-disabled_action');
    if (enabledPreview) {
      jQuery('#gf-preview').removeClass('gf-disabled_action');
    }
    jQuery('#gf-publish').removeClass('gf-disabled_action');
    if (enabledViewlive) {
      jQuery('#gf-view').removeClass('gf-disabled_action');
    }
  },
  getLoading3DotTemplate: function (text) {
    return (
      '<div class="gfLoader-3Dots" style="margin:0;font-size:14px"> <span class="gfLoader-status status">' +
      text +
      '</span> <span class="gfLoader-3Dots-dot1">.</span> <span class="gfLoader-3Dots-dot2">.</span> <span class="gfLoader-3Dots-dot3">.</span> </div>'
    );
  },
  getDefaultPublishButtonTemplate: function () {
    return '<span><span class="publish_text">Publish</span> <svg class="need_a_name" height="8px" viewBox="0 0 8 8"> <path d="M4,5.29l2.65-2.65c0.2-0.2,0.51-0.2,0.71,0c0.2,0.2,0.2,0.51,0,0.71l-3,3c-0.2,0.2-0.51,0.2-0.71,0l-3-3c-0.2-0.2-0.2-0.51,0-0.71c0.2-0.2,0.51-0.2,0.71,0L4,5.29z"></path></svg></span>';
  },

  //
  getDataNameScreen: function (dataName, screenType) {
    const attrScrollSpeed = dataName;
    if (!screenType || screenType == 'lg') {
      return dataName;
    }
    return dataName + '-' + screenType;
  },
  transformCategory: function (cat) {
    if (!cat) return '';
    return cat.toLowerCase().replace(' ', '-');
  },
  findMaxNumberInArray: function (array) {
    if (!array || !array.length) return 0;

    let max = array[0];
    for (let i = 0; i < array.length; i++) {
      if (max < array[i]) {
        max = array[i];
      }
    }
    return max;
  },
  findObjectInArrayByKey: function (key, array) {
    let objectFound = null;
    for (let i = 0; i < array.length; i++) {
      if (array[i][key]) {
        objectFound = array[i];
        break;
      }
    }
    return objectFound;
  },
  updateValueInArrayByKey: function (object, array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i][object.key]) {
        array[i][object.key] = object.value;
      }
    }
  },
  timeAgo: function (time) {
    switch (typeof time) {
      case 'number':
        break;

      case 'string':
        time = +new Date(time);
        break;

      case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;

      default:
        time = +new Date();
    }
    const time_formats = [
      [60, 'seconds', 1], // 60
      [120, '1 minute ago', '1 minute from now'], // 60*2
      [3600, 'minutes', 60], // 60*60, 60
      [7200, '1 hour ago', '1 hour from now'], // 60*60*2
      [86400, 'hours', 3600], // 60*60*24, 60*60
      [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
      [604800, 'days', 86400], // 60*60*24*7, 60*60*24
      [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
    let seconds = (+new Date() - time) / 1000,
      token = 'ago',
      list_choice = 1;

    if (seconds == 0) {
      return 'Just now';
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      token = 'from now';
      list_choice = 2;
    }
    let i = 0,
      format;

    while ((format = time_formats[i++]))
      if (seconds < format[0]) {
        if (typeof format[2] == 'string') return format[list_choice];
        else return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
      }

    return time;
  },
  isVietnamese: function (shop) {
    const hasVi = window.navigator.languages.join('; ').toLowerCase().indexOf('vi') > -1;
    const fromVi = shop.country.toUpperCase() == 'VIETNAM';

    let langVi = false;

    if (shop) {
      langVi = shop.language.toUpperCase() == 'VI' || shop.language.toUpperCase() == 'VN';
    }

    if (langVi || hasVi || fromVi) {
      return true;
    }

    return false;
  },
  getAceMode: function (type) {
    switch ((type || '').toLowerCase()) {
      case 'template':
        return 'ace/mode/html';
      case 'style':
        return 'ace/mode/css';
      case 'script':
        return 'ace/mode/javascript';
      case 'data':
        return 'ace/mode/json';
    }
  },
  handleBlankPage: function () {
    setTimeout(() => {
      const dataSettingSize = Object.keys(app.$store.state['editor'].dataSettings).length;
      if (dataSettingSize === 0) {
        app.$store.state['editor'].isBlankPage = true;
        emitter.emit('page:blank', true);
      } else {
        app.$store.state['editor'].isBlankPage = false;
        emitter.emit('page:blank', false);
      }
    });
  },
  mergeDataSetting: function (type, attrId) {
    const $gfFrame = jQuery('#gfFrame');

    let interactionTemplate = jQuery(`<div class="interaction"></div>`);
    let actionTemplate = jQuery(`<div class="actions"></div>`);

    const interactionData = app.$store.getters['editor/GET_ANIMATION_INTERACTION_SETTING_BY_KEY'](
      base._interactions + '_' + type + '-' + attrId,
    );

    if (interactionData) {
      interactionTemplate = jQuery(`<div class="interaction"></div>`).append(interactionData);
    }

    const actionData = app.$store.getters['editor/GET_ANIMATION_ACTION_SETTING_BY_KEY'](
      base._actions + '_' + type + '-' + attrId,
    );
    if (actionData) {
      actionTemplate = jQuery(`<div class="actions"></div>`).append(actionData);
    }

    let $bkClone = '';
    const keySnippet = this.getKeyDataSetting(base._snippet, attrId, type);
    const $snippet = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySnippet);

    const keyTemplate = this.getKeyDataSetting(base._template, attrId, type);
    const $template = jQuery(
      `<script class="template" type="text/plain" id="${attrId}">${app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](
        keyTemplate,
      )}</script>`,
    );

    const keyData = this.getKeyDataSetting(base._data, attrId, type);
    const $data = jQuery(
      `<script class="data" type="application/json">${app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](
        keyData,
      )}</script>`,
    );

    const keyLibs = this.getKeyDataSetting(base._libs, attrId, type);
    const $libs = jQuery(
      `<script class="libs" type="application/json">${app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](
        keyLibs,
      )}</script>`,
    );

    const keySettings = this.getKeyDataSetting(base._settings, attrId, type);
    const dataSettings = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
    let $settings;
    if (typeof dataSettings != 'string') {
      $settings = jQuery(`<script class="settings" type="application/json">${JSON.stringify(dataSettings)}</script>`);
    } else {
      $settings = jQuery(`<script class="settings" type="application/json">${dataSettings}</script>`);
    }

    const keyStyle = this.getKeyDataSetting(base._style, attrId, type);
    const $style = jQuery(
      `<style rel="stylesheet" class="style" type="text/css">${app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](
        keyStyle,
      )}</style>`,
    );

    const keyBkStyle = this.getKeyDataSetting(base._bkStyle, attrId, type);
    const $bkStyle = jQuery(
      `<style rel="stylesheet" class="bkstyle" type="text/css">${app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](
        keyBkStyle,
      )}</style>`,
    );

    const keyScript = this.getKeyDataSetting(base._script, attrId, type);
    const $script = jQuery(
      `<script class="script" type="text/plain" defer="defer">${app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](
        keyScript,
      )}</script>`,
    );

    const $dataAtomSetting = jQuery(
      `<script class="data-atom-settings" type="application/json">${app.$store.getters[
        'editor/GET_DATA_SETTING_BY_KEY'
      ](attrId)}</script>`,
    );

    const keyTemplateChildHtml = this.getKeyDataSetting(base._templateChildHtml, attrId, type);
    const dataTemplateChildHtml = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildHtml);
    const $templateChildHtml = jQuery(
      `<script class="template-child-html" type="text/plain">${dataTemplateChildHtml}</script>`,
    );

    const keyTemplateChildBkHtml = this.getKeyDataSetting(base._templateChildBkHtml, attrId, type);
    const dataTemplateChildBkHtml = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyTemplateChildBkHtml);
    const $templateChildBkHtml = jQuery(
      `<script class="template-child-bkhtml" type="text/plain">${dataTemplateChildBkHtml}</script>`,
    );

    $bkClone = jQuery(`<div id="${type}-${attrId}" />`).html($snippet);

    $bkClone.append($template);
    $bkClone.append($data);
    $bkClone.append($libs);
    $bkClone.append($settings);
    $bkClone.append($style);
    $bkClone.append($bkStyle);
    $bkClone.append($script);
    $bkClone.append($dataAtomSetting);

    if (dataTemplateChildHtml) {
      $bkClone.append($templateChildHtml);
    }
    if (dataTemplateChildBkHtml) {
      $bkClone.append($templateChildBkHtml);
    }

    if (interactionData) {
      $bkClone.append(interactionTemplate);
    }

    if (actionData) {
      $bkClone.append(actionTemplate);
    }
    return $bkClone;
  },
  getStyleDataSetting: function (type, attrId) {
    const keyStyle = this.getKeyDataSetting(base._style, attrId, type);
    return app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyStyle);
  },
  getScriptDataSetting: function (type, attrId) {
    const keyStyle = this.getKeyDataSetting(base._script, attrId, type);
    return app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyStyle);
  },
  getKeyDataSetting: function (keyType, attrId, type = 'module') {
    return `${keyType}-${type}-${attrId}`;
  },
  getKeyEditorDataSetting: function (attrId) {
    return `${base._editor}-${attrId}`;
  },
  getDataKeyMER: function ($element) {
    if ($element.data('gfelement') != undefined) {
      return $element.data('gfelement').getElementKey();
    } else if ($element.data('gfmodule') != undefined) {
      return $element.data('gfmodule').getModuleKey();
    } else if ($element.data('gfrow') != undefined) {
      return $element.data('gfrow').getRowKey();
    }
    return '';
  },
  getDataTypeMER: function ($element) {
    if ($element.hasClass('element-wrap')) {
      return 'element';
    } else if ($element.hasClass('module-wrap')) {
      return 'module';
    } else if ($element.hasClass('gf_row')) {
      return 'row';
    }
    return '';
  },
  getDataIdMER: function ($element) {
    if ($element.data('gfelement') != undefined) {
      return $element.data('gfelement').getElementId();
    } else if ($element.data('gfmodule') != undefined) {
      return $element.data('gfmodule').getModuleId();
    } else if ($element.data('gfrow') != undefined) {
      return $element.data('gfrow').getRowId();
    }
    return '';
  },

  getParentMERByChild: function ($element) {
    if (
      $element.hasClass('gf_row') ||
      $element.hasClass('gf_column') ||
      $element.hasClass('module-wrap') ||
      $element.hasClass('element-wrap')
    ) {
      return $element;
    } else {
      return $element.closest('.element-wrap, .module-wrap, .gf_row');
    }
  },

  getDataEditorInfo: function (attrId) {
    const keyEditorInfo = getKeyEditorDataSetting(attrId);
    const isExistEditorInfo = app.$store.getters['editor/EXIST_KEY_DATA_SETTING'](keyEditorInfo);
    if (!isExistEditorInfo) return {};
    const dataEditorInfo = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyEditorInfo);
    const parseData = dataEditorInfo && JSON.parse(data);
    return parseData;
  },
  getDataGSInEditorInfo: function (attrId) {
    const dataEditorInfo = this.getDataEditorInfo(attrId);
    const dataGS = dataEditorInfo?.data?.globalStyle || {};
    return dataGS;
  },
  setDataGSForEditorInfo: function (dataGlobalStyle, attrId) {
    const dataEditorInfo = this.getDataEditorInfo(attrId);
    dataEditorInfo.data.globalStyle = dataGlobalStyle;
    const keyEditorInfo = getKeyEditorDataSetting(attrId);
    app.$store.commit('editor/SET_DATA_SETTINGS', {
      id: keyEditorInfo,
      value: JSON.stringify(dataEditorInfo),
    });
    return;
  },
  /**
   * detachKeyDataSetting
   * typeDetach: id (#m-xxx || #e-xxx || #r-xxx), dataId (xxx), typeId (element || row || module)
   */
  detachKeyDataSetting: function (key, typeDetach) {
    if (!key || typeof key !== 'string') return false;
    const keyPartsMatch = key.match(/^(.*)-(module|element|row)-(.*)$/);
    if (keyPartsMatch && keyPartsMatch.length === 4) {
      let elementType = '#m-';
      if (keyPartsMatch[2] === 'row') {
        elementType = '#r-';
      } else if (keyPartsMatch[2] === 'element') {
        elementType = '#e-';
      }
      const dataId = keyPartsMatch[3];
      const id = elementType + dataId;
      switch (typeDetach) {
        case 'id':
          return id;
        case 'dataId':
          return dataId;
        case 'typeId':
          return keyPartsMatch[2];
      }
    }
    return false;
  },

  /**
   * getRoundNumber
   * return: 0->1
   */
  getRoundNumber: function (value) {
    const res = Math.round(value * 100) / 100;
    return typeof res ? res : 0;
  },

  setPreviewViewUrl: function (handle) {
    const $gryffEditor = getGlobalVariable('gryffEditor');
    const $dataGryffEditor = $gryffEditor.data('gryffeditor');
    if ($dataGryffEditor) {
      let preViewPageLink = $dataGryffEditor.getPreviewPageLink();
      preViewPageLink = preViewPageLink.replace(/&product(.*)/, '&product=' + handle);

      let viewPageLink = $dataGryffEditor.getViewPageLink();
      viewPageLink = viewPageLink.replace(/\/products\/(.*)/, '/products/' + handle);

      $dataGryffEditor.setPreviewPageLink(preViewPageLink);
      $dataGryffEditor.setViewPageLink(viewPageLink);
    }
  },

  getDefaultNoImage: function () {
    return '/editor/static/icons/no-image.gif';
  },

  removeProductModuleMessage: function ($html) {
    const demoMessage = $html.find('.gf-demo');
    const notFoundMessage = $html.find('.gf_product-not-found');

    if (checkKeyValid('productDemo') && demoMessage) {
      demoMessage.remove();
    }
    if (checkKeyValid('productNotFound') && notFoundMessage) {
      notFoundMessage.remove();
    }
  },

  getImageProductNotFound: function () {
    return '/editor/static/icons/assign-product-no-pselected.svg';
  },

  handleProductNotFound: function (isHasProductNotFound = false) {
    const oldIsProductNotFound = app.$store.getters['page/GET_IS_PRODUCT_NOT_FOUND'];
    if (oldIsProductNotFound == isHasProductNotFound) {
      return;
    }
    const $mdSettings = jQuery('#md-settings');
    if (isHasProductNotFound) {
      $mdSettings.find('.gfProductThumb').find('img').attr('src', HELPER.getImageProductNotFound());
      $mdSettings.find('.gfProductTitle').html('Product Not Found');
    } else {
      const $inputProductTitleAssigned = $mdSettings.find('#assigned-product');
      const $inpurProductTitleManual = $mdSettings.find('#assign-select-product');

      // Product Assigned
      let titleProductAssigned = 'No product assigned';
      changeProductTitlePreview($inputProductTitleAssigned, titleProductAssigned);

      // Product Manual
      const titleProductManual = 'No product selected';
      // $inpurProductTitleManual.html(titleProductManual);
      changeProductTitlePreview($inpurProductTitleManual, titleProductManual);

      $mdSettings.find('.gfProductThumb').find('img').attr('src', HELPER.getImageProductNotFound());
    }
    app.$store.commit('page/IS_PRODUCT_NOT_FOUND', isHasProductNotFound);
    return;
  },

  getYoutubeThumb: function (urlYoutube) {
    let thumbHtml = 'Error! Cannot generate youtube video.';
    if (urlYoutube != undefined) {
      const videoID = this.getYoutubeVideoId(urlYoutube);
      const url = `https://img.youtube.com/vi/${videoID}/default.jpg`;
      const urlHD = `https://img.youtube.com/vi/${videoID}/maxresdefault.jpg`;
      thumbHtml = '<div class="gf_youtube-container">';
      thumbHtml +=
        '<style>.gf_youtube-container{cursor: pointer;position:relative;z-index:1;width:100%;height:0;padding-bottom:56.27198%}.gf_youtube-container img{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1}.gf_youtube-container svg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2;width:68px}</style>';
      thumbHtml += '<img class="gf_youtube-thumb" src="' + url + '" data-src="' + urlHD + '" />';
      thumbHtml +=
        '<svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg>';
      thumbHtml += '</div>';
    }
    return thumbHtml;
  },

  getYoutubeVideoId: function (urlYoutube) {
    let videoID = '';
    if (urlYoutube.indexOf('youtu.be/') != -1) videoID = urlYoutube.split('youtu.be/');
    else videoID = urlYoutube.split(/watch\?v=/);
    if (videoID && videoID[1] != undefined) {
      videoID = videoID[1].split(/&/)[0];
    }
    return videoID;
  },

  noScriptFromLiquid: function (html) {
    const $html = jQuery('<div/>').append(html);
    $html.find('.module-wrap').each(function () {
      const label = jQuery(this).attr('data-label');
      if (label === 'Liquid') {
        jQuery(this).find('script, link')?.remove();
      }
    });

    return $html.html();
  },
};
export default HELPER;

/**
 * Encode a text into HTML pre-render code
 * @param {String} text text to be encode
 * @returns {String}
 */
export const encodeHTML = function (text) {
  return text.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
    return '&#' + i.charCodeAt(0) + ';';
  });
};

const transformRegexvalue = (name) => {
  return '{{(\\s*?)' + name + '(\\s*?)}}';
};

/**
 * Init ace editor
 * @param {String} id element id
 * @param {String} tab
 * @param {String} mode
 * @return {Editor}
 */
export function initAce(id, tab = '', mode = '') {
  if (!id || id == '') {
    return null;
  }
  const $el = ace.edit(id);
  $el.setTheme('ace/theme/monokai');
  $el.setAutoScrollEditorIntoView(true);
  $el.getSession().setTabSize(2);
  $el.getSession().setUseWrapMode(true);
  $el.setHighlightActiveLine(false);
  $el.setOption('maxLines', 27);
  $el.setOption('minLines', 27);
  if (!mode || mode == '') {
    $el.session.setMode(HELPER.getAceMode(tab));
  } else {
    $el.session.setMode(mode);
  }
  if (tab && tab != '') {
    $el.container.id = id + 'Editor';
    jQuery($el.container).attr('gf-tab-content', tab);
  }
  return $el;
}

/**
 * Copy a text string to clipboard
 * @param {String} text text to copy
 */
export function copyToClipboard(text) {
  const _$input = document.createElement('input');
  _$input.value = text;
  document.body.appendChild(_$input);
  _$input.focus();
  _$input.select();
  try {
    const cpy = document.execCommand('copy');
    // on success
    return true;
  } catch (error) {
    // on fail
    document.body.removeChild(_$input);
    console.error(error);
    return false;
  }
}

export function sanitizeDescription(description) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(description, 'text/html');
  const div = doc.querySelector('div.gf_product-desc');
  if (div.innerHTML.includes('/a/gc/gift-card/')) div.innerHTML = '&nbsp;';
  if (checkKeyValid('sanitizeDescription')) {
    doc.querySelectorAll('script').forEach((script) => script.remove());
  }

  return doc.body.innerHTML;
}
